/* eslint-disable */
// Auto-generated Larinz Labz bundle — all source React components from the
// original bundled HTML, preserved verbatim. Functions share module scope.
// Page components are exported for React Router consumption.

import React from 'react';
import '@/larinz/sanitize';  // registers window.LL_sanitizeHTML for SVG/HTML overrides

if (typeof window !== 'undefined') {
  window.React = React;
}

// The inline App page components rely on these unqualified hooks (they came
// from an inline `<script type="text/babel">` where React was a global).
const { useState, useEffect } = React;


/* ===== Source: 80b7ecc5-637b-4afd-ad69-d1f8350ce8b1.js ===== */
/* eslint-disable */
// Shared responsive hook — returns true when the viewport is phone-width.
// Used across components to switch from desktop grids to stacked mobile layouts.
// All inline-styled components read this since CSS media queries can't target inline styles.

function useIsMobile(breakpoint = 760) {
  const [mobile, setMobile] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );
  React.useEffect(() => {
    const onResize = () => setMobile(window.innerWidth <= breakpoint);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return mobile;
}

// Mid-size (tablet) helper when a layout needs a third breakpoint.
function useViewport() {
  const [w, setW] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1280);
  React.useEffect(() => {
    const on = () => setW(window.innerWidth);
    on();
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return { width: w, isMobile: w <= 760, isTablet: w > 760 && w <= 1024 };
}

Object.assign(window, { useIsMobile, useViewport });

/* ===== Source: 06b5d834-9013-467e-8842-2a54cf6821b9.js ===== */
/* eslint-disable */
// Shared media lightbox — plays a video INSIDE the site (modal overlay) instead of
// navigating away. Handles three source kinds, auto-detected from the URL:
//   • direct file (.mp4/.mov/.webm)  → <video> element, autoplay+controls
//   • YouTube / Vimeo                → <iframe> embed
//   • anything else (e.g. Instagram) → shows an "Open on Instagram" button (those
//     platforms block inline embedding), so it gracefully falls back to a link.
//
// Open it from anywhere: window.LLLightbox.open({ src, poster, title })
// It mounts a single global instance listening for a custom event.

function MediaLightbox() {
  const [state, setState] = React.useState(null); // { src, poster, title } | null

  React.useEffect(() => {
    const onOpen = (e) => setState(e.detail);
    window.addEventListener('ll-lightbox-open', onOpen);
    return () => window.removeEventListener('ll-lightbox-open', onOpen);
  }, []);

  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setState(null); };
    if (state) window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [state]);

  if (!state) return null;
  const { src, title } = state;
  const isImage = state.image || /^data:image|\.(jpe?g|png|gif|webp|avif|svg)(\?|#|$)/i.test(src || '');
  const kind = isImage ? 'image' : detectVideoKind(src);

  return (
    <div
      onClick={() => setState(null)}
      style={{
        position: 'fixed', inset: 0, zIndex: 9000,
        background: 'rgba(0,0,0,.92)', backdropFilter: 'blur(8px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, animation: 'llFade .2s ease',
      }}>
      <style>{`@keyframes llFade{from{opacity:0}to{opacity:1}}`}</style>

      {/* Close */}
      <button
        onClick={() => setState(null)}
        style={{
          position: 'absolute', top: 22, right: 26, zIndex: 2,
          width: 44, height: 44, borderRadius: '50%', cursor: 'pointer',
          background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.2)',
          color: '#fff', fontSize: 22, lineHeight: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>×</button>

      {kind === 'image' ? (
        <div onClick={e => e.stopPropagation()} style={{
          position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center',
          maxWidth: '95vw', maxHeight: '95vh',
        }}>
          <img src={src} alt={title || ''} style={{
            maxWidth: '95vw', maxHeight: '95vh', objectFit: 'contain',
            borderRadius: 8, display: 'block', boxShadow: '0 30px 90px rgba(0,0,0,.6)',
          }} />
          {title && <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            padding: '40px 20px 16px', textAlign: 'center',
            background: 'linear-gradient(to top, rgba(0,0,0,.7), transparent)',
            color: '#fff', fontWeight: 800, fontSize: 15, textTransform: 'uppercase', letterSpacing: -0.3,
            borderBottomLeftRadius: 8, borderBottomRightRadius: 8,
          }}>{title}</div>}
        </div>
      ) : (
      <div onClick={e => e.stopPropagation()} style={{
        position: 'relative',
        width: 'min(92vw, 440px)',
        aspectRatio: '9/16', maxHeight: '88vh',
        background: '#000', borderRadius: 16, overflow: 'hidden',
        boxShadow: '0 30px 90px rgba(0,0,0,.6)',
      }}>
        {kind === 'file' && (
          <video src={src} controls autoPlay playsInline
            style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000' }} />
        )}
        {kind === 'embed' && (
          <iframe src={toEmbed(src)} allow="autoplay; fullscreen; encrypted-media" allowFullScreen
            style={{ width: '100%', height: '100%', border: 'none' }} />
        )}
        {kind === 'external' && (
          <div style={{
            position: 'absolute', inset: 0,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            gap: 18, padding: 32, textAlign: 'center',
            background: 'linear-gradient(160deg, #1a1a1a, #0a0a0a)',
          }}>
            <div style={{
              width: 64, height: 64, borderRadius: '50%', background: 'var(--ll-accent, #A5FF12)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="22" height="22" viewBox="0 0 14 14" fill="#111"><polygon points="3,1 13,7 3,13" /></svg>
            </div>
            {title && <div style={{ color: '#fff', fontWeight: 800, fontSize: 18, textTransform: 'uppercase', letterSpacing: -0.5 }}>{title}</div>}
            <div style={{ color: 'rgba(255,255,255,.5)', fontSize: 13, lineHeight: 1.6, maxWidth: 280 }}>
              This reel plays on its original platform.
            </div>
            <a href={src} target="_blank" rel="noopener noreferrer"
              onClick={() => { try { window.open(src, '_blank', 'noopener'); } catch (e) { console.warn('lightbox open failed:', e); } }}
              style={{
                background: 'var(--ll-accent, #A5FF12)', color: '#111', fontWeight: 800,
                fontSize: 13, letterSpacing: 1, textTransform: 'uppercase',
                padding: '12px 26px', borderRadius: 999, textDecoration: 'none',
              }}>Open Video ↗</a>
          </div>
        )}
      </div>
      )}
    </div>
  );
}

// Detect how to present a video URL.
function detectVideoKind(url) {
  const u = (url || '').toLowerCase();
  if (!u) return 'external';
  if (u.startsWith('data:video') || /\.(mp4|mov|webm|m4v|ogv)(\?|#|$)/.test(u)) return 'file';
  if (/youtube\.com|youtu\.be|vimeo\.com|player\.cloudinary|player\.vimeo/.test(u)) return 'embed';
  return 'external'; // instagram, tiktok, etc — can't inline-embed
}

function toEmbed(url) {
  let m;
  if ((m = url.match(/youtu\.be\/([\w-]+)/)))            return `https://www.youtube.com/embed/${m[1]}?autoplay=1&playsinline=1`;
  if ((m = url.match(/youtube\.com\/watch\?v=([\w-]+)/))) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&playsinline=1`;
  if ((m = url.match(/vimeo\.com\/(\d+)/)))               return `https://player.vimeo.com/video/${m[1]}?autoplay=1`;
  return url;
}

// Helper components call this to open the lightbox.
function openLightbox(detail) {
  window.dispatchEvent(new CustomEvent('ll-lightbox-open', { detail }));
}

Object.assign(window, { MediaLightbox, openLightbox, detectVideoKind });

/* ===== Source: 4c1397e2-c0cb-45cb-8a72-61d9fe323b6b.js ===== */
/* eslint-disable */
// Empty-state placeholder used on Work, Studio, Reels, Brands, custom sections.
// Quietly invites the user to open the Dashboard and add content.

function EmptyState({ theme = 'light', title, body, action }) {
  const isDark = theme === 'dark';
  const fg = isDark ? '#fff' : '#111';
  const muted = isDark ? 'rgba(255,255,255,.55)' : '#888';
  const border = isDark ? 'rgba(255,255,255,.12)' : '#E0E0E0';
  return (
    <div style={{
      border: `1.5px dashed ${border}`,
      borderRadius: 14,
      padding: '64px 32px',
      textAlign: 'center',
      background: isDark ? 'rgba(255,255,255,.02)' : '#FAFAF7',
    }}>
      <div style={{
        width: 48, height: 48, margin: '0 auto 20px',
        borderRadius: 12, background: 'rgba(165,255,18,.12)',
        border: '1px solid rgba(165,255,18,.4)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--ll-accent, #A5FF12)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </div>
      <h3 style={{
        fontWeight: 900, fontSize: 22, letterSpacing: -0.8, color: fg,
        textTransform: 'uppercase', margin: '0 0 8px',
      }}>{title}</h3>
      <p style={{
        fontSize: 14, color: muted, fontWeight: 300,
        maxWidth: 420, margin: '0 auto 20px', lineHeight: 1.7,
      }}>{body}</p>
      {action && (
        <button onClick={action.onClick} style={{
          background: 'var(--ll-accent, #A5FF12)', color: '#111', border: 'none',
          padding: '10px 22px', borderRadius: 4,
          fontSize: 12, fontWeight: 800, letterSpacing: 0.3,
          textTransform: 'uppercase', cursor: 'pointer',
          fontFamily: 'Inter, sans-serif',
        }}>{action.label} →</button>
      )}
    </div>
  );
}

Object.assign(window, { EmptyState });

/* ===== Source: a49adaba-6a88-4646-942b-7eb8f9bc0c6a.js ===== */
/* eslint-disable */
// Unified outline icon set. Single source of truth for every glyph on the site.
// Always renders at 2px stroke, round caps/joins, inheriting currentColor unless
// `color` is passed. Switch by `name` prop.
//
// To add a new icon: drop a new <case> below. Keep paths inside viewBox 0 0 24 24.
//
// Overrides: window.LL_DATA.iconOverrides[name] = '<svg ...>…</svg>'  (full SVG string)
// is rendered verbatim, with currentColor/size handled by a wrapper <span>.

function Icon({ name, size = 22, color, strokeWidth = 2, style }) {
  // Custom uploaded SVG override (from dashboard → Icons tab)
  const override = (window.LL_DATA && window.LL_DATA.iconOverrides || {})[name];
  if (override) {
    return (
      <span
        style={{
          display: 'inline-flex', width: size, height: size,
          color: color || 'currentColor', ...style,
        }}
        dangerouslySetInnerHTML={{ __html: window.LL_sanitizeHTML ? window.LL_sanitizeHTML(override) : override }} />
    );
  }

  const props = {
    width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
    stroke: color || 'currentColor',
    strokeWidth, strokeLinecap: 'round', strokeLinejoin: 'round',
    style,
  };
  switch (name) {
    case 'camera':
      return <svg {...props}><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" /><circle cx="12" cy="13" r="4" /></svg>;
    case 'video':
      return <svg {...props}><polygon points="23 7 16 12 23 17 23 7" /><rect x="1" y="5" width="15" height="14" rx="2" /></svg>;
    case 'social':
      return <svg {...props}><rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="3" /><circle cx="17.5" cy="6.5" r="0.8" fill={color || 'currentColor'} /></svg>;
    case 'target':
      return <svg {...props}><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></svg>;
    case 'bolt':
      return <svg {...props}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>;
    case 'handshake':
      return <svg {...props}><path d="M3 13l4-4 3 3 6-6 5 5"/><path d="M14 8l3-3"/><path d="M3 18l4 3 5-3 4 3 5-4"/></svg>;
    case 'mail':
      return <svg {...props}><rect x="2" y="4" width="20" height="16" rx="2" /><polyline points="2 6 12 13 22 6" /></svg>;
    case 'instagram':
      return <svg {...props}><rect x="2" y="2" width="20" height="20" rx="5" /><path d="M16 11.4A4 4 0 1 1 12.6 8 4 4 0 0 1 16 11.4z"/><line x1="17.5" y1="6.5" x2="17.5" y2="6.5" strokeWidth="2.5" /></svg>;
    case 'pin':
      return <svg {...props}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
    case 'package':
      return <svg {...props}><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 002 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>;
    case 'arrowRight':
      return <svg {...props}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>;
    case 'check':
      return <svg {...props}><polyline points="20 6 9 17 4 12" /></svg>;
    case 'play':
      return <svg {...props} fill={color || 'currentColor'} stroke="none"><polygon points="6 4 20 12 6 20 6 4"/></svg>;
    default:
      return <svg {...props}><circle cx="12" cy="12" r="10" /></svg>;
  }
}

// Map common emoji → icon name so existing data continues to work.
function emojiToIcon(emoji) {
  const map = {
    '📷': 'camera',
    '🎥': 'video',
    '📊': 'social',
    '🎯': 'target',
    '⚡': 'bolt',
    '🤝': 'handshake',
    '📧': 'mail',
    '📸': 'instagram',
    '📍': 'pin',
    '✦': 'target',
  };
  return map[emoji] || null;
}

Object.assign(window, { Icon, emojiToIcon });

/* ===== Source: bf248866-91c2-4bc7-a45a-997936fdd2ae.js ===== */
/* eslint-disable */
// Logo — uses window.LL_DATA.logo so Dashboard upload reflects everywhere.

function Logo({ variant = 'dark', height = 44 }) {
  const isLight = variant === 'light';
  const src = (window.LL_DATA && window.LL_DATA.logo) || 'data:image/png;base64,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';
  return (
    <img
      src={src}
      alt={(window.LL_DATA && window.LL_DATA.brandName) || 'LARINZ LABZ'}
      style={{
        height,
        width: 'auto',
        display: 'block',
        filter: isLight ? 'invert(1) hue-rotate(180deg) saturate(2)' : 'none',
      }}
    />
  );
}

function Monogram({ size = 32, stroke = '#111' }) {
  const m = (window.LL_DATA && window.LL_DATA.monogram) || {};
  // Custom uploaded image / SVG takes priority
  if (m.src) {
    return (
      <img src={m.src} alt="" style={{
        width: size, height: size * 28 / 32,
        objectFit: 'contain', display: 'block',
      }} />
    );
  }
  // Custom text (e.g. "LL", "M", initials)
  if (m.text) {
    return (
      <div style={{
        width: size, height: size * 28 / 32,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: stroke, fontWeight: 900,
        fontSize: size * 0.6, letterSpacing: -1, lineHeight: 1,
        fontFamily: 'Inter, sans-serif',
      }}>{m.text}</div>
    );
  }
  return (
    <svg width={size} height={size * 28 / 32} viewBox="0 0 56 44" fill="none">
      <path d="M4 4 L4 32 Q4 36 8 36 L18 36" stroke={stroke} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M26 4 L26 32 Q26 36 30 36 L40 36" stroke={stroke} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Object.assign(window, { Logo, Monogram });

/* ===== Source: 1f83cfba-7c3e-4331-bcb4-d4989f236b66.js ===== */
/* eslint-disable */
// Button primitives. All take {label, onClick, ...}

function BtnGreen({ label = 'Get In Touch', onClick, size = 'md' }) {
  const sizes = {
    sm: { padding: '9px 22px', fontSize: 13 },
    md: { padding: '14px 32px', fontSize: 14 },
    lg: { padding: '15px 36px', fontSize: 15 },
  };
  return (
    <button onClick={onClick} style={{
      background: 'var(--ll-accent, #A5FF12)', color: '#111', border: 'none',
      borderRadius: 4, fontWeight: 800, fontFamily: 'Inter, sans-serif',
      letterSpacing: '-0.2px', cursor: 'pointer',
      display: 'inline-flex', alignItems: 'center', alignSelf: 'flex-start', width: 'fit-content',
      transition: 'opacity .2s, transform .2s',
      ...sizes[size],
    }}
      onMouseEnter={e => { e.currentTarget.style.opacity = '.88'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'none'; }}
    >{label} →</button>
  );
}

function BtnDark({ label = 'View Our Work', onClick }) {
  return (
    <button onClick={onClick} style={{
      background: '#111', color: '#fff', border: 'none',
      borderRadius: 4, padding: '14px 32px', fontSize: 14, fontWeight: 700,
      fontFamily: 'Inter, sans-serif', cursor: 'pointer',
      display: 'inline-flex', alignItems: 'center', alignSelf: 'flex-start', width: 'fit-content',
      transition: 'opacity .2s, transform .2s',
    }}
      onMouseEnter={e => { e.currentTarget.style.opacity = '.85'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'none'; }}
    >{label} →</button>
  );
}

function BtnOutline({ label = 'Learn More', onClick, theme = 'light' }) {
  const isLight = theme === 'light';
  return (
    <button onClick={onClick} style={{
      background: 'transparent',
      color: isLight ? '#111' : '#fff',
      border: `1.5px solid ${isLight ? 'rgba(0,0,0,.08)' : 'rgba(255,255,255,.2)'}`,
      borderRadius: 4, padding: '13px 28px', fontSize: 14, fontWeight: 700,
      fontFamily: 'Inter, sans-serif', cursor: 'pointer',
      display: 'inline-flex', alignItems: 'center', alignSelf: 'flex-start', width: 'fit-content',
      transition: 'border-color .2s',
    }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = isLight ? '#111' : '#fff'; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = isLight ? 'rgba(0,0,0,.08)' : 'rgba(255,255,255,.2)'; }}
    >{label}</button>
  );
}

function BtnGhost({ label, onClick }) {
  return (
    <button onClick={onClick} style={{
      background: 'transparent', color: 'var(--ll-accent, #A5FF12)',
      border: '1px solid #A5FF12', borderRadius: 4,
      padding: '10px 22px', fontSize: 12, fontWeight: 700,
      letterSpacing: 1, textTransform: 'uppercase',
      fontFamily: 'Inter, sans-serif', cursor: 'pointer',
      display: 'inline-flex', alignItems: 'center', alignSelf: 'flex-start', width: 'fit-content',
      transition: 'background .2s, color .2s',
    }}
      onMouseEnter={e => { e.currentTarget.style.background = 'var(--ll-accent, #A5FF12)'; e.currentTarget.style.color = '#111'; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--ll-accent, #A5FF12)'; }}
    >{label} →</button>
  );
}

function Eyebrow({ children, theme = 'light' }) {
  return (
    <div style={{
      fontSize: 10, fontWeight: 700, letterSpacing: 4,
      textTransform: 'uppercase', color: 'var(--ll-accent, #A5FF12)',
      display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 14,
    }}>
      <span style={{ width: 20, height: 2, background: 'var(--ll-accent, #A5FF12)' }} />
      {children}
    </div>
  );
}

Object.assign(window, { BtnGreen, BtnDark, BtnOutline, BtnGhost, Eyebrow });

/* ===== Source: 6d7ef72f-8469-4e6b-97a2-1e104e9c7b91.js ===== */
/* eslint-disable */
// Sticky top navigation bar. Light or dark.

function Nav({ variant = 'light', current = 'home', onNav }) {
  const isLight = variant === 'light';
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  const links = [
    { id: 'home', label: 'Home' },
    { id: 'work', label: 'Work' },
    { id: 'studio', label: 'Studio' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' },
  ];
  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 800,
      height: 68, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: isMobile ? '0 18px' : '0 48px',
      background: isLight ? 'rgba(255,255,255,.96)' : 'rgba(13,13,13,.92)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderBottom: `1px solid ${isLight ? 'rgba(0,0,0,.06)' : 'rgba(255,255,255,.06)'}`,
    }}>
      <div onClick={() => onNav && onNav('home')} style={{ cursor: 'pointer', flexShrink: 0 }}>
        <Logo variant={isLight ? 'dark' : 'light'} height={isMobile ? 30 : 36} />
      </div>
      <ul style={{ display: 'flex', gap: isMobile ? 15 : 32, listStyle: 'none', margin: 0, padding: 0 }}>
        {links.map(l => (
          <li key={l.id}>
            <span onClick={() => onNav && onNav(l.id)} style={{
              fontSize: isMobile ? 12 : 13, fontWeight: current === l.id ? 700 : 500,
              cursor: 'pointer', letterSpacing: '.2px', whiteSpace: 'nowrap',
              color: current === l.id
                ? (isLight ? '#111' : '#fff')
                : (isLight ? 'rgba(0,0,0,.45)' : 'rgba(255,255,255,.5)'),
              transition: 'color .2s',
            }}>{l.label}</span>
          </li>
        ))}
      </ul>
      {!isMobile && <BtnGreen label="Get Free Audit" size="sm" onClick={() => onNav && onNav('contact')} />}
    </nav>
  );
}

Object.assign(window, { Nav });

/* ===== Source: 34f2e044-af23-497f-9007-cfa0badfad26.js ===== */
/* eslint-disable */
// Split-screen homepage hero — WHITE left panel + DARK right with cycling media.
// Reads window.LL_DATA.hero.mediaList: array of { type: 'video'|'image', src }.
// Falls back to legacy single reelEmbed URL if mediaList is empty.

function Hero({ onNav }) {
  const h = window.LL_DATA.hero || {};
  const services = h.services || [];
  const labels = h.rightLabels || [];
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;

  // Build the rotation list. Prefer mediaList, fall back to reelEmbed (single iframe).
  const mediaList = (h.mediaList || []).filter(m => m && m.src);
  const [activeIdx, setActiveIdx] = React.useState(0);
  const cycleSec = h.mediaCycleSec || 8;

  React.useEffect(() => {
    if (mediaList.length < 2) return;
    const t = setInterval(() => setActiveIdx(i => (i + 1) % mediaList.length), cycleSec * 1000);
    return () => clearInterval(t);
  }, [mediaList.length, cycleSec]);

  const activeMedia = mediaList[activeIdx];

  return (
    <section style={{
      minHeight: isMobile ? 'auto' : '100vh', background: '#fff',
      display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      position: 'relative', overflow: 'hidden',
    }}>

      {/* LEFT — WHITE */}
      <div style={{
        background: '#fff', padding: isMobile ? '32px 24px 48px' : '52px 8%',
        display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
        position: 'relative', zIndex: 2, order: isMobile ? 2 : 1,
        minHeight: isMobile ? 'auto' : 0,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Logo variant="dark" height={52} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
            {[
              { label: 'Home',    id: 'home',    active: true },
              { label: 'Work',    id: 'work' },
              { label: 'Studio',  id: 'studio' },
              { label: 'About',   id: 'about' },
              { label: 'Contact', id: 'contact' },
            ].map(item => (
              <span key={item.id} onClick={() => onNav && onNav(item.id)} style={{
                fontSize: 11, fontWeight: 600,
                color: item.active ? '#111' : '#888',
                letterSpacing: 1.5, textTransform: 'uppercase', cursor: 'pointer',
                transition: 'color .2s',
              }}>{item.label}</span>
            ))}
          </div>
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: isMobile ? '32px 0 8px' : '40px 0' }}>
          <Eyebrow>{h.eyebrow || 'A Creative Studio'}</Eyebrow>
          <h1 style={{
            fontWeight: 900, fontSize: isMobile ? 'clamp(40px, 13vw, 64px)' : 'clamp(48px, 6vw, 88px)',
            letterSpacing: -3, lineHeight: 0.88, color: '#111',
            textTransform: 'uppercase', margin: '0 0 20px',
          }}>
            {h.h1Top || 'WE TURN'}<br />
            {h.h1Mid || 'IDEAS INTO'}<br />
            <span style={{ color: 'var(--ll-accent, #A5FF12)' }}>{h.h1End || 'IMPACT.'}</span>
          </h1>
          {services.length > 0 && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 32 }}>
              {services.map((s, i) => (
                <span key={s + i} style={{
                  fontSize: 10, fontWeight: 700, letterSpacing: 1.5,
                  textTransform: 'uppercase', color: '#888',
                  display: 'flex', alignItems: 'center', gap: 6,
                }}>
                  {i > 0 && <span style={{ color: 'var(--ll-accent, #A5FF12)', fontSize: 14, fontWeight: 900 }}>·</span>}
                  {s}
                </span>
              ))}
            </div>
          )}
          <BtnDark label={h.ctaLabel || 'View Our Work'} onClick={() => onNav && onNav('work')} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div>
            <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#E0E0E0', marginBottom: 5 }}>{window.LL_DATA.tagline}</div>
            <div style={{ fontSize: 13, fontWeight: 300, color: '#888', lineHeight: 1.6, maxWidth: 260 }}>{h.tagline}</div>
          </div>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 2, color: '#E0E0E0', textTransform: 'uppercase' }}>LARINZLABZ.COM</div>
        </div>
      </div>

      {/* RIGHT — Media panel */}
      <div style={{ position: 'relative', overflow: 'hidden', background: '#000', zIndex: 1, order: isMobile ? 1 : 2, minHeight: isMobile ? '62vh' : 0 }}>
        {/* Render layered media so the active one fades in. */}
        {mediaList.length > 0 ? (
          mediaList.map((m, i) => (
            <MediaLayer key={i} media={m} active={i === activeIdx} />
          ))
        ) : (
          // Legacy single iframe fallback
          h.reelEmbed && (
            <iframe
              src={h.reelEmbed}
              style={{
                position: 'absolute', top: '50%', left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '177.78%', height: '100%',
                minWidth: '100%', minHeight: '177.78%',
                border: 'none', pointerEvents: 'none',
              }}
              allow="autoplay; fullscreen"
            />
          )
        )}

        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,.15)', pointerEvents: 'none' }} />

        {labels.length > 0 && (
          <div style={{ position: 'absolute', top: 28, right: 28, textAlign: 'right' }}>
            {labels.map((l, i) => (
              <div key={i} style={{
                fontSize: 9, fontWeight: 700, letterSpacing: 3,
                color: i === labels.length - 1 ? 'var(--ll-accent, #A5FF12)' : '#fff',
                textTransform: 'uppercase', lineHeight: 1.8,
              }}>{l}</div>
            ))}
          </div>
        )}

        {/* Cycle indicators */}
        {mediaList.length > 1 && (
          <div style={{ position: 'absolute', bottom: 90, left: 28, display: 'flex', gap: 6 }}>
            {mediaList.map((_, i) => (
              <span key={i} style={{
                width: i === activeIdx ? 24 : 8, height: 3,
                background: i === activeIdx ? 'var(--ll-accent, #A5FF12)' : 'rgba(255,255,255,.3)',
                borderRadius: 2, transition: 'all .4s cubic-bezier(.16,1,.3,1)',
              }} />
            ))}
          </div>
        )}

        {h.est && (
          <div style={{ position: 'absolute', bottom: 28, left: 28, fontSize: 9, fontWeight: 700, letterSpacing: 3, color: '#fff', textTransform: 'uppercase' }}>{h.est}</div>
        )}
        <div style={{
          position: 'absolute', bottom: 0, right: 0,
          width: 72, height: 72, background: 'var(--ll-accent, #A5FF12)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Monogram size={32} stroke="#111" />
        </div>
      </div>
    </section>
  );
}

/* One media layer (video, image, or iframe embed). Fades in when active. */
function MediaLayer({ media, active }) {
  const style = {
    position: 'absolute', inset: 0,
    width: '100%', height: '100%',
    objectFit: 'cover',
    opacity: active ? 1 : 0,
    transition: 'opacity .8s cubic-bezier(.16,1,.3,1)',
    pointerEvents: 'none',
  };
  if (media.type === 'video') {
    return (
      <video src={media.src} autoPlay muted loop playsInline style={style} />
    );
  }
  if (media.type === 'embed') {
    return (
      <iframe src={media.src} style={{
        ...style,
        top: '50%', left: '50%', inset: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '177.78%', height: '100%',
        minWidth: '100%', minHeight: '177.78%',
        border: 'none',
      }} allow="autoplay; fullscreen" />
    );
  }
  // default: image (poster fallback)
  return <img src={media.src} style={style} />;
}

Object.assign(window, { Hero });

/* ===== Source: 9ed52202-2d1e-4882-84d6-a7bb362e15b0.js ===== */
/* eslint-disable */
// 3-up service grid: CAPTURE. CREATE. CONNECT.
// Clicking a card opens the ServiceModal with deliverables.

function ServicesGrid() {
  const items = window.LL_DATA.services || [];
  const [active, setActive] = React.useState(null);
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  if (items.length === 0) return null;

  // Show the first 3 services here (the homepage tiles).
  const visible = items.slice(0, 3);

  return (
    <section style={{ background: '#fff', padding: isMobile ? '56px 24px' : '72px 10%', borderBottom: '1px solid #E0E0E0' }}>
      <div style={{ marginBottom: isMobile ? 28 : 40 }}>
        <Eyebrow>Services</Eyebrow>
        <h2 style={{
          fontWeight: 900, fontSize: 'clamp(32px, 4vw, 56px)',
          letterSpacing: -2, textTransform: 'uppercase', color: '#111', margin: 0,
        }}>WHAT WE DO</h2>
        <p style={{ fontSize: 15, color: '#888', marginTop: 12, fontWeight: 300, maxWidth: 500 }}>
          {items.map(s => s.name).slice(0, 5).join(' · ')}
        </p>
      </div>
      <div style={{
        display: 'grid', gridTemplateColumns: isMobile ? '1fr' : `repeat(${visible.length}, 1fr)`, gap: 1,
        background: '#E0E0E0', border: '1px solid #E0E0E0',
        borderRadius: 16, overflow: 'hidden',
      }}>
        {visible.map(s => (
          <ServiceCard key={s.id} service={s} onClick={() => setActive(s)} />
        ))}
      </div>
      <ServiceModal service={active} onClose={() => setActive(null)} onContact={() => {
        // Navigate to contact — fire a global event the App listens for.
        window.dispatchEvent(new CustomEvent('ll-nav', { detail: 'contact' }));
      }} />
    </section>
  );
}

function ServiceCard({ service, onClick }) {
  const [hover, setHover] = React.useState(false);
  const { name, sub, short, desc } = service;
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: hover ? '#FAFFF0' : '#fff',
        padding: '40px 28px',
        position: 'relative', overflow: 'hidden', cursor: 'pointer',
        transition: 'background .3s',
      }}>
      <div style={{
        position: 'absolute', bottom: 0, left: 0,
        height: 3, background: 'var(--ll-accent, #A5FF12)',
        width: hover ? '100%' : 0,
        transition: 'width .5s cubic-bezier(.16,1,.3,1)',
      }} />
      <div style={{
        fontWeight: 900, fontSize: 'clamp(22px, 2.5vw, 36px)',
        letterSpacing: -2, color: '#111', textTransform: 'uppercase',
        lineHeight: 1, marginBottom: 10,
      }}>{name}<span style={{ color: 'var(--ll-accent, #A5FF12)' }}>.</span></div>
      {sub && <div style={{ fontSize: 11, color: '#888', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginBottom: 20 }}>{sub}</div>}
      <div style={{ fontSize: 14, color: '#888', lineHeight: 1.75, fontWeight: 300, marginBottom: 28 }}>{short || desc}</div>
      <div style={{
        fontSize: 12, color: 'var(--ll-accent, #A5FF12)', fontWeight: 700,
        letterSpacing: 0.5, textTransform: 'uppercase',
        display: 'inline-flex', alignItems: 'center', gap: hover ? 14 : 8,
        transition: 'gap .2s',
      }}>LEARN MORE →</div>
    </div>
  );
}

Object.assign(window, { ServicesGrid });

/* ===== Source: 37a401ba-7bf9-4cad-bc94-c23a09ef4122.js ===== */
/* eslint-disable */
// "WHAT WE DO" — the 2×2 services overview from the Work page.
// Cards are clickable and open the ServiceModal (deliverables popup).

function Services2x2() {
  const items = window.LL_DATA.services || [];
  const [active, setActive] = React.useState(null);
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  if (items.length === 0) return null;

  return (
    <section style={{ background: '#fff', padding: isMobile ? '56px 24px 40px' : '80px 10% 60px' }}>
      <div style={{ marginBottom: isMobile ? 28 : 48 }}>
        <Eyebrow>Services</Eyebrow>
        <h2 style={{
          fontWeight: 900, fontSize: 'clamp(40px, 6vw, 88px)',
          letterSpacing: -3, lineHeight: 0.9, textTransform: 'uppercase',
          color: '#111', margin: 0,
        }}>WHAT WE DO</h2>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 12 : 20 }}>
        {items.map(s => (
          <Service2x2Card key={s.id} service={s} onClick={() => setActive(s)} />
        ))}
      </div>
      <ServiceModal service={active} onClose={() => setActive(null)} onContact={() => {
        window.dispatchEvent(new CustomEvent('ll-nav', { detail: 'contact' }));
      }} />
    </section>
  );
}

function Service2x2Card({ service, onClick }) {
  const [hover, setHover] = React.useState(false);
  const { name, short, icon } = service;
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: hover ? '#FAFFF0' : '#F5F5F5',
        border: `1.5px solid ${hover ? 'var(--ll-accent, #A5FF12)' : 'transparent'}`,
        borderRadius: 14,
        padding: '24px 22px',
        display: 'flex', alignItems: 'center', gap: 20,
        cursor: 'pointer',
        position: 'relative', overflow: 'hidden',
        transition: 'background .25s, border-color .25s',
      }}>
      <div style={{
        position: 'absolute', bottom: 0, left: 0,
        height: 3, background: 'var(--ll-accent, #A5FF12)',
        width: hover ? '100%' : 0,
        transition: 'width .5s cubic-bezier(.16,1,.3,1)',
      }} />
      <div style={{
        width: 64, height: 64, borderRadius: 14,
        background: '#fff', border: '1px solid #EAEAE6',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, color: '#111',
      }}>
        <Icon name={emojiToIcon(icon) || 'target'} size={26} color="var(--ll-accent, #A5FF12)" strokeWidth={2} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h3 style={{
          fontWeight: 900, fontSize: 22, letterSpacing: -0.8,
          textTransform: 'uppercase', color: '#111',
          margin: '0 0 6px',
        }}>{name}<span style={{ color: 'var(--ll-accent, #A5FF12)' }}>.</span></h3>
        <p style={{ fontSize: 14, color: '#888', fontWeight: 400, marginBottom: 16 }}>{short}</p>
        <div style={{
          fontSize: 11, color: 'var(--ll-accent, #A5FF12)', fontWeight: 800,
          letterSpacing: 2, textTransform: 'uppercase',
          display: 'inline-flex', alignItems: 'center', gap: hover ? 12 : 8,
          transition: 'gap .2s',
        }}>LEARN MORE →</div>
      </div>
    </div>
  );
}

Object.assign(window, { Services2x2 });

/* ===== Source: ad124e8d-0349-42c3-adaf-507ddebb13cc.js ===== */
/* eslint-disable */
// ServiceModal — opens when a service card (CAPTURE/CREATE/CONNECT, or one of
// the WHAT WE DO 2×2 tiles) is clicked. Lists the full description + deliverable
// chips, matches the pattern on larinzlabz.com.

function ServiceModal({ service, onClose, onContact }) {
  React.useEffect(() => {
    const h = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);

  if (!service) return null;

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,.6)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      zIndex: 900, display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 16,
        width: '90%', maxWidth: 600, maxHeight: '85vh',
        overflowY: 'auto', padding: '48px 10%', position: 'relative',
      }}>
        <button onClick={onClose} style={{
          position: 'absolute', top: 20, right: 20,
          background: '#F5F5F5', border: 'none', color: '#111',
          width: 34, height: 34, borderRadius: '50%',
          fontSize: 16, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background .2s',
        }}
          onMouseEnter={e => e.currentTarget.style.background = '#E0E0E0'}
          onMouseLeave={e => e.currentTarget.style.background = '#F5F5F5'}
        >✕</button>

        <div style={{ width: 48, height: 4, background: 'var(--ll-accent, #A5FF12)', borderRadius: 2, marginBottom: 20 }} />

        {service.icon && (
          <div style={{ marginBottom: 12, color: '#111' }}>
            <Icon name={emojiToIcon(service.icon) || 'target'} size={32} color="var(--ll-accent, #A5FF12)" strokeWidth={2} />
          </div>
        )}

        <h2 style={{
          fontWeight: 900, fontSize: 32, letterSpacing: -1.5,
          color: '#111', marginBottom: 6, textTransform: 'uppercase',
        }}>{service.name}<span style={{ color: 'var(--ll-accent, #A5FF12)' }}>.</span></h2>

        <div style={{
          fontSize: 12, color: '#888', fontWeight: 700, letterSpacing: 2,
          textTransform: 'uppercase', marginBottom: 20,
        }}>What's included</div>

        <p style={{
          fontSize: 15, color: '#444', lineHeight: 1.8,
          fontWeight: 300, marginBottom: 28,
        }}>{service.full || service.short || service.desc}</p>

        {(service.deliverables || []).length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 32 }}>
            {service.deliverables.map((d, i) => (
              <span key={i} style={{
                fontSize: 12, background: '#F5F5F5', color: '#111',
                padding: '6px 14px', borderRadius: 4, fontWeight: 600,
              }}>{d}</span>
            ))}
          </div>
        )}

        <BtnGreen label="Start a Project" onClick={() => { onContact && onContact(); onClose(); }} />
      </div>
    </div>
  );
}

Object.assign(window, { ServiceModal });

/* ===== Source: f9e6af28-8438-4d6a-be5d-ddefde74448a.js ===== */
/* eslint-disable */
// Viral-reel CAROUSEL — arrow navigation pages through the reels.
// Each reel can either NAVIGATE to a link (Instagram) or PLAY INLINE in a lightbox
// (hosted mp4 / YouTube / Vimeo). View-count numbers intentionally omitted.

function ReelsGrid() {
  const reels = window.LL_DATA.reels || [];
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  const perPage = isMobile ? 2 : 3;
  const [page, setPage] = React.useState(0);

  const pageCount = Math.max(1, Math.ceil(reels.length / perPage));
  const clampedPage = Math.min(page, pageCount - 1);
  React.useEffect(() => { if (page !== clampedPage) setPage(clampedPage); }, [pageCount]);

  const go = (dir) => setPage(p => (p + dir + pageCount) % pageCount);

  const Header = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: isMobile ? 28 : 48, gap: 16, flexWrap: 'wrap' }}>
      <div>
        <Eyebrow>Viral Content</Eyebrow>
        <h2 style={{
          fontWeight: 900, fontSize: 'clamp(28px, 7vw, 64px)',
          letterSpacing: -2, lineHeight: .95, textTransform: 'uppercase',
          color: '#fff', margin: 0,
        }}>MOMENTS THAT<br />BREAK THE INTERNET</h2>
      </div>
      {reels.length > perPage && (
        <div style={{ display: 'flex', gap: 10 }}>
          <CarouselArrow dir="prev" onClick={() => go(-1)} />
          <CarouselArrow dir="next" onClick={() => go(1)} />
        </div>
      )}
    </div>
  );

  if (reels.length === 0) {
    return (
      <section style={{ background: '#0D0D0D', padding: isMobile ? '64px 24px' : '100px 10%' }}>
        <div style={{ marginBottom: 52 }}>
          <Eyebrow>Viral Content</Eyebrow>
          <h2 style={{
            fontWeight: 900, fontSize: 'clamp(32px, 5vw, 64px)',
            letterSpacing: -2, lineHeight: .95, textTransform: 'uppercase',
            color: '#fff', margin: 0,
          }}>MOMENTS THAT<br />BREAK THE INTERNET</h2>
        </div>
        <EmptyState theme="dark"
          title="No viral reels yet"
          body="Open the Dashboard → Reels to add reel posters and links (Instagram, YouTube, or a hosted video)." />
      </section>
    );
  }

  const start = clampedPage * perPage;
  const visible = reels.slice(start, start + perPage);

  return (
    <section style={{ background: '#0D0D0D', padding: isMobile ? '64px 24px' : '100px 10%', overflow: 'hidden' }}>
      {Header}

      {/* Track — a fresh keyed wrapper per page so it re-animates on each change. */}
      <div key={clampedPage} style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${perPage}, 1fr)`,
        gap: isMobile ? 8 : 12,
        animation: 'reelSlide .45s cubic-bezier(.16,1,.3,1)',
      }}>
        <style>{`@keyframes reelSlide{from{opacity:0;transform:translateX(24px)}to{opacity:1;transform:translateX(0)}}`}</style>
        {visible.map(r => <ReelCard key={r.id} {...r} />)}
      </div>

      {/* Dots */}
      {pageCount > 1 && (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 28 }}>
          {Array.from({ length: pageCount }).map((_, i) => (
            <button key={i} onClick={() => setPage(i)} style={{
              width: i === clampedPage ? 26 : 8, height: 8, borderRadius: 999,
              border: 'none', cursor: 'pointer', padding: 0,
              background: i === clampedPage ? 'var(--ll-accent, #A5FF12)' : 'rgba(255,255,255,.22)',
              transition: 'width .3s, background .3s',
            }} />
          ))}
        </div>
      )}
    </section>
  );
}

function CarouselArrow({ dir, onClick }) {
  const [hover, setHover] = React.useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label={dir === 'next' ? 'Next' : 'Previous'}
      style={{
        width: 50, height: 50, borderRadius: '50%', cursor: 'pointer',
        background: hover ? 'var(--ll-accent, #A5FF12)' : 'transparent',
        border: `1.5px solid ${hover ? 'var(--ll-accent, #A5FF12)' : 'rgba(255,255,255,.25)'}`,
        color: hover ? '#111' : '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'all .2s',
      }}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
        style={{ transform: dir === 'prev' ? 'rotate(180deg)' : 'none' }}>
        <path d="M5 12h14M13 6l6 6-6 6" />
      </svg>
    </button>
  );
}

function ReelCard({ handle, title, brand, img, url, playType }) {
  const [hover, setHover] = React.useState(false);
  // 'inline' → open lightbox and play in-site.  'link' (default) → open the URL.
  const inline = playType === 'inline';

  const activate = (e) => {
    if (!url) { e.preventDefault(); return; }
    e.preventDefault();
    if (inline) {
      window.openLightbox && window.openLightbox({ src: url, title, poster: img });
    } else {
      try { const w = window.open(url, '_blank', 'noopener,noreferrer'); if (!w) window.location.href = url; }
      catch (err) { window.location.href = url; }
    }
  };

  return (
    <a href={url || '#'} onClick={activate}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        textDecoration: 'none', borderRadius: 12, overflow: 'hidden',
        background: '#111', border: `1px solid ${hover ? 'var(--ll-accent, #A5FF12)' : 'rgba(255,255,255,.05)'}`,
        cursor: 'pointer',
        transform: hover ? 'translateY(-5px)' : 'none',
        transition: 'border-color .3s, transform .4s cubic-bezier(.16,1,.3,1)',
      }}>
      <div style={{ aspectRatio: '9/16', position: 'relative', overflow: 'hidden' }}>
        {img
          ? <img src={img} style={{
              width: '100%', height: '100%', objectFit: 'cover',
              transform: hover ? 'scale(1.05)' : 'scale(1)',
              transition: 'transform .6s cubic-bezier(.16,1,.3,1)',
            }} />
          : <div style={{ width: '100%', height: '100%', background: 'linear-gradient(180deg, #1a1a1a, #0d0d0d)' }} />
        }
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,.92) 0%, rgba(0,0,0,.15) 50%, transparent 100%)', pointerEvents: 'none' }} />
        {handle && (
          <div style={{
            position: 'absolute', top: 12, right: 12, fontSize: 11,
            color: 'rgba(255,255,255,.65)', background: 'rgba(0,0,0,.55)',
            padding: '3px 9px', borderRadius: 20, backdropFilter: 'blur(6px)',
          }}>{handle}</div>
        )}
        {inline && (
          <div style={{
            position: 'absolute', top: 12, left: 12, fontSize: 9, fontWeight: 800,
            letterSpacing: 1, textTransform: 'uppercase',
            color: '#111', background: 'var(--ll-accent, #A5FF12)',
            padding: '3px 8px', borderRadius: 4,
          }}>Plays here</div>
        )}
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{
            width: 50, height: 50, borderRadius: '50%',
            background: hover ? 'var(--ll-accent, #A5FF12)' : 'rgba(165,255,18,.85)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transform: hover ? 'scale(1.14)' : 'scale(1)',
            transition: 'transform .25s cubic-bezier(.16,1,.3,1)',
          }}>
            <svg width="16" height="16" viewBox="0 0 14 14" fill="#111">
              <polygon points="3,1 13,7 3,13" />
            </svg>
          </div>
        </div>
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: 18 }}>
          {title && <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', lineHeight: 1.3, marginBottom: 3 }}>{title}</div>}
          {brand && <div style={{ fontSize: 11, color: 'rgba(255,255,255,.3)' }}>{brand}</div>}
        </div>
      </div>
    </a>
  );
}

Object.assign(window, { ReelsGrid });

/* ===== Source: a72991ee-21e7-44e4-a8c9-31bf2b5cbafe.js ===== */
/* eslint-disable */
// Client-brand grid. Shows 4 brands by default; "View all →" toggles the rest.

function BrandsGrid({ onNav, onOpen }) {
  const brands = window.LL_DATA.brands || [];
  const [showAll, setShowAll] = React.useState(false);
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  const VISIBLE = 4;
  const visible = showAll ? brands : brands.slice(0, VISIBLE);
  const hasMore = brands.length > VISIBLE;

  return (
    <section style={{ background: '#fff', padding: isMobile ? '56px 24px' : '100px 10%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <Eyebrow>Success Stories</Eyebrow>
          <h2 style={{
            fontWeight: 900, fontSize: 'clamp(32px, 5vw, 64px)',
            letterSpacing: -2, lineHeight: .95, textTransform: 'uppercase',
            color: '#111', margin: 0,
          }}>BRANDS WE'VE<br />TRANSFORMED</h2>
        </div>
        {hasMore && (
          <span onClick={() => setShowAll(s => !s)} style={{
            fontSize: 13, color: '#888', cursor: 'pointer', fontWeight: 700,
            transition: 'color .2s',
          }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--ll-accent, #A5FF12)'}
            onMouseLeave={e => e.currentTarget.style.color = '#888'}
          >{showAll ? 'Show less ↑' : `View all (${brands.length}) →`}</span>
        )}
      </div>
      {brands.length === 0 ? (
        <div style={{ marginTop: 40 }}>
          <EmptyState
            title="No clients yet"
            body="Add your brand wins from the Dashboard — name, location, and result." />
        </div>
      ) : (
        <div style={{ marginTop: isMobile ? 32 : 52, display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: 10 }}>
          {visible.map(b => <BrandCard key={b.id} {...b} onNav={onNav} onOpen={onOpen} />)}
        </div>
      )}
    </section>
  );
}

function BrandCard({ name, loc, initials, color, result, logo, onNav, onOpen }) {
  const [hover, setHover] = React.useState(false);
  const norm = s => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const handleView = () => {
    const projects = window.LL_DATA.projects || [];
    const match = projects.find(p => norm(p.name) === norm(name));
    if (match && onOpen) onOpen(match);
    else if (onNav) onNav('work');
  };
  return (
    <div
      onClick={handleView}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: hover ? '#FAFFF0' : '#F5F5F5',
        border: `1px solid ${hover ? 'var(--ll-accent, #A5FF12)' : '#E0E0E0'}`,
        borderRadius: 10, padding: '20px 22px',
        display: 'flex', alignItems: 'center', gap: 16, cursor: 'pointer',
        transform: hover ? 'translateY(-2px)' : 'none',
        transition: 'all .22s',
      }}>
      <div style={{
        width: 60, height: 60, borderRadius: '50%',
        background: color || '#111',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#fff', fontWeight: 900, fontSize: 18, letterSpacing: -1,
        flexShrink: 0, overflow: 'hidden',
      }}>
        {logo ? <img src={logo} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (initials || '?')}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 800, color: '#111', letterSpacing: -0.3, marginBottom: 2 }}>{name}</div>
        {loc && <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>{loc}</div>}
        {result && (
          <div style={{
            display: 'inline-block',
            background: 'rgba(165,255,18,.15)', color: '#5a8a00',
            fontSize: 11, fontWeight: 700, padding: '3px 10px',
            borderRadius: 3, letterSpacing: 0.3,
          }}>{result}</div>
        )}
      </div>
      <div style={{
        flexShrink: 0, background: 'transparent',
        color: hover ? '#111' : '#888', fontSize: 12, fontWeight: 600,
        padding: '7px 16px', borderRadius: 20,
        border: `1px solid ${hover ? 'var(--ll-accent, #A5FF12)' : '#E0E0E0'}`,
        whiteSpace: 'nowrap', transition: 'all .2s',
      }}>View</div>
    </div>
  );
}

Object.assign(window, { BrandsGrid });

/* ===== Source: 9a998673-d062-4157-a332-03cb54926450.js ===== */
/* eslint-disable */
// Work-page project grid with empty-state.

function WorkGrid({ onOpen }) {
  const projects = window.LL_DATA.projects || [];
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  if (projects.length === 0) {
    return (
      <section style={{ background: '#fff', padding: isMobile ? '0 24px 56px' : '0 10% 80px' }}>
        <EmptyState
          title="Your portfolio starts here"
          body="Open the Dashboard to add your first project — cover photo, services, story, palette and a gallery." />
      </section>
    );
  }
  const [first, ...rest] = projects;
  const pairs = [];
  for (let i = 0; i < rest.length; i += 2) {
    pairs.push(rest.slice(i, i + 2));
  }
  return (
    <section style={{ background: '#fff', padding: isMobile ? '0 24px 56px' : '0 10% 80px' }}>
      <WorkItem variant="full" project={first} onOpen={onOpen} />
      {pairs.map((pair, i) => (
        <div key={i} style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 40 : 48, marginBottom: isMobile ? 40 : 80 }}>
          {pair.map(p => <WorkItem key={p.id} variant="half" project={p} onOpen={onOpen} />)}
        </div>
      ))}
    </section>
  );
}

function WorkItem({ variant, project, onOpen }) {
  const [hover, setHover] = React.useState(false);
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  const aspectRatio = variant === 'full' ? (isMobile ? '4/3' : '21/9') : '4/3';
  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => onOpen && onOpen(project)}
      style={{
        marginBottom: variant === 'full' ? (isMobile ? 40 : 80) : 0,
        cursor: 'pointer',
        position: 'relative',
      }}>
      <div style={{
        position: 'relative', overflow: 'hidden',
        borderRadius: 8, marginBottom: 20, background: '#1a1a1a',
        aspectRatio,
      }}>
        {project.cover && (
          <img src={project.cover} style={{
            width: '100%', height: '100%', objectFit: 'cover',
            transform: hover ? 'scale(1.06)' : 'scale(1.02)',
            transition: 'transform .8s cubic-bezier(.16,1,.3,1)',
          }} />
        )}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'rgba(0,0,0,.6)',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          textAlign: 'center', padding: 32,
          opacity: hover ? 1 : 0,
          transition: 'opacity .4s cubic-bezier(.16,1,.3,1)',
        }}>
          <div style={{
            fontWeight: 900, fontSize: 'clamp(28px, 4vw, 52px)',
            letterSpacing: -2, color: '#fff', textTransform: 'uppercase',
            lineHeight: .95, marginBottom: 12,
          }}>{project.name}</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,.7)', letterSpacing: 3, textTransform: 'uppercase', fontWeight: 600 }}>{project.type}</div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '0 2px', gap: 16 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{
            fontWeight: 900, fontSize: 'clamp(22px, 3vw, 36px)',
            letterSpacing: -1, lineHeight: 1.04,
            color: hover ? 'var(--ll-accent, #A5FF12)' : '#111',
            textTransform: 'uppercase', marginBottom: 8,
            transition: 'color .2s',
          }}>{project.name}</div>
          <div style={{ fontSize: 12, color: '#888', fontWeight: 500, letterSpacing: 0.5, textTransform: 'uppercase' }}>{project.type}</div>
        </div>
        <div style={{
          fontSize: 24, color: hover ? 'var(--ll-accent, #A5FF12)' : '#E0E0E0',
          marginTop: 8, transform: hover ? 'translateX(8px)' : 'none',
          transition: 'color .3s, transform .3s cubic-bezier(.16,1,.3,1)',
        }}>→</div>
      </div>
    </div>
  );
}

Object.assign(window, { WorkGrid });

/* ===== Source: a4ee99b1-9134-4d91-9996-3d1c41c19099.js ===== */
/* eslint-disable */
// Infinite-scroll service marquee on dark.

function Marquee() {
  const items = ['PHOTOGRAPHY', 'VIDEOGRAPHY', 'SOCIAL MEDIA', 'BRAND STRATEGY', 'CONTENT THAT PERFORMS'];
  const looped = [...items, ...items, ...items];
  return (
    <>
      <style>{`
        @keyframes ll-marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .ll-marquee-track { animation: ll-marquee 22s linear infinite; }
        .ll-marquee-track:hover { animation-play-state: paused; }
      `}</style>
      <div style={{
        overflow: 'hidden', whiteSpace: 'nowrap',
        borderTop: '1px solid rgba(255,255,255,.1)',
        borderBottom: '1px solid rgba(255,255,255,.1)',
        padding: '14px 0', background: '#0D0D0D',
      }}>
        <div className="ll-marquee-track" style={{ display: 'inline-block' }}>
          {looped.map((t, i) => (
            <span key={i}>
              <span style={{
                display: 'inline-block', fontSize: 13, fontWeight: 700,
                letterSpacing: 3, textTransform: 'uppercase',
                color: 'rgba(255,255,255,.35)', padding: '0 40px',
              }}>{t}</span>
              <span style={{ color: 'var(--ll-accent, #A5FF12)', marginRight: 0 }}>·</span>
            </span>
          ))}
        </div>
      </div>
    </>
  );
}

Object.assign(window, { Marquee });

/* ===== Source: 2a26d08d-f69f-4b61-a8be-d7205f87400b.js ===== */
/* eslint-disable */
// Dark 4-column footer. Content from LL_DATA so Dashboard edits show.

function Footer({ onNav }) {
  const c = window.LL_DATA.contact || {};
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  return (
    <footer style={{ background: '#0D0D0D', padding: isMobile ? '52px 24px 0' : '72px 10% 0', borderTop: '1px solid rgba(255,255,255,.05)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : '2fr 1fr 1fr 1fr', gap: isMobile ? 32 : 48 }}>
        <div style={{ gridColumn: isMobile ? '1 / -1' : 'auto' }}>
          <Logo variant="light" height={48} />
          <div style={{
            fontSize: 10, letterSpacing: 3, color: 'var(--ll-accent, #A5FF12)',
            textTransform: 'uppercase', fontWeight: 700, marginTop: 14, marginBottom: 14,
          }}>{window.LL_DATA.tagline}</div>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,.28)', lineHeight: 1.7, maxWidth: 240, fontWeight: 300 }}>
            Creative studio specializing in media, ideas &amp; strategy. We build brands that dominate their market.
          </p>
        </div>
        <FtCol title="Navigate" items={[
          { label: 'Work', onClick: () => onNav && onNav('work') },
          { label: 'Studio', onClick: () => onNav && onNav('studio') },
          { label: 'About', onClick: () => onNav && onNav('about') },
          { label: 'Contact', onClick: () => onNav && onNav('contact') },
        ]} />
        <FtCol title="Services" items={[
          { label: 'Photography' }, { label: 'Videography' }, { label: 'Social Media' },
          { label: 'Brand Strategy' }, { label: 'Content Strategy' },
        ]} />
        <FtCol title="Contact" items={[
          c.email     && { label: c.email },
          c.instagram && { label: c.instagram },
          c.location  && { label: c.location },
        ].filter(Boolean)} />
      </div>
      <div style={{
        padding: '24px 0', borderTop: '1px solid rgba(255,255,255,.05)',
        display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
        fontSize: 12, color: 'rgba(255,255,255,.18)', marginTop: isMobile ? 40 : 60,
      }}>
        <span>© {new Date().getFullYear()} {window.LL_DATA.brandName || 'LARINZ LABZ'}. All rights reserved.</span>
        <span>Privacy · Terms</span>
      </div>
    </footer>
  );
}

function FtCol({ title, items }) {
  return (
    <div>
      <h4 style={{
        fontSize: 10, color: 'rgba(255,255,255,.2)',
        letterSpacing: 2.5, textTransform: 'uppercase',
        margin: '0 0 20px', fontWeight: 700,
      }}>{title}</h4>
      {(items || []).map((it, i) => (
        <a key={i} onClick={it.onClick} style={{
          display: 'block', fontSize: 13, color: 'rgba(255,255,255,.38)',
          marginBottom: 12, cursor: it.onClick ? 'pointer' : 'default',
          textDecoration: 'none',
        }}>{it.label}</a>
      ))}
    </div>
  );
}

Object.assign(window, { Footer });

/* ===== Source: c3127808-636f-4437-8e81-2f76a5c73eb0.js ===== */
/* eslint-disable */
// STUDIO — redesigned white editorial portfolio.
// Reads from window.LL_DATA.studio. Items render as a clean masonry-style grid
// with hover-zoom and category eyebrows. Comfortable to browse, on-brand.

function StudioPage({ onNav }) {
  const studio = window.LL_DATA.studio || { items: [] };
  const items = studio.items || [];
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;

  // Filter chips
  const allCats = ['ALL', ...Array.from(new Set(items.map(i => (i.category || '').toUpperCase()).filter(Boolean)))];
  const [filter, setFilter] = React.useState('ALL');
  const filtered = filter === 'ALL'
    ? items
    : items.filter(i => (i.category || '').toUpperCase() === filter);

  return (
    <div data-screen-label="03 Studio">
      {/* ── HERO (light, editorial) ──────────────────────────── */}
      <section style={{
        background: '#fff', padding: isMobile ? '110px 24px 48px' : '160px 10% 80px',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          maxWidth: 1200, margin: '0 auto',
          display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1.4fr 1fr', gap: isMobile ? 28 : 80, alignItems: 'end',
        }}>
          <div>
            <Eyebrow>{studio.eyebrow || 'Visual Production'}</Eyebrow>
            <h1 style={{
              fontWeight: 900, fontSize: isMobile ? 'clamp(56px, 18vw, 92px)' : 'clamp(56px, 8vw, 132px)',
              letterSpacing: -5, lineHeight: 0.88, textTransform: 'uppercase',
              color: '#111', margin: '0 0 28px',
            }}>{(studio.h1 || 'STUDIO.').replace(/\.$/, '')}<span style={{ color: 'var(--ll-accent, #A5FF12)' }}>.</span></h1>
            <p style={{
              fontSize: isMobile ? 16 : 18, color: '#444', lineHeight: 1.75, fontWeight: 300,
              maxWidth: 540, margin: 0,
            }}>{studio.intro || 'Photography · Videography · Packaging — visuals that stop the scroll and define your brand.'}</p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14, alignItems: isMobile ? 'flex-start' : 'flex-end' }}>
            <BtnGreen label="Book A Shoot" onClick={() => onNav && onNav('contact')} />
            <div style={{ fontSize: 11, color: '#888', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700 }}>
              {items.length} {items.length === 1 ? 'piece' : 'pieces'} in portfolio
            </div>
          </div>
        </div>

        {/* Discipline strip — light variant */}
        <div style={{
          maxWidth: 1200, margin: isMobile ? '40px auto 0' : '64px auto 0',
          display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)', gap: 0,
          borderTop: '1px solid #EAEAE6', borderBottom: '1px solid #EAEAE6',
        }}>
          {[
            { icon: 'camera',  title: 'Photography',  body: 'Product · Lifestyle · Editorial' },
            { icon: 'video',   title: 'Videography',  body: 'Cinematic · Brand films · Reels' },
            { icon: 'social',  title: 'Short-Form',   body: 'Reels · TikTok · Stories' },
            { icon: 'package', title: 'Print',        body: 'Packaging · Menus · Signage' },
          ].map((s, i) => <DisciplineCell key={i} {...s} last={i === 3} />)}
        </div>
      </section>

      {/* ── PORTFOLIO ──────────────────────────────────────── */}
      <section style={{ background: '#FAFAF7', padding: isMobile ? '48px 20px' : '80px 10%' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 36, flexWrap: 'wrap', gap: 20 }}>
            <div>
              <Eyebrow>Selected Work</Eyebrow>
              <h2 style={{
                fontWeight: 900, fontSize: 'clamp(32px, 5vw, 56px)',
                letterSpacing: -2, lineHeight: .95, textTransform: 'uppercase',
                color: '#111', margin: 0,
              }}>PHOTOS &amp; FILMS<span style={{ color: 'var(--ll-accent, #A5FF12)' }}>.</span></h2>
            </div>
            {allCats.length > 1 && (
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {allCats.map(c => (
                  <button key={c} onClick={() => setFilter(c)} style={{
                    fontSize: 11, fontWeight: 700, padding: '8px 18px', borderRadius: 999,
                    border: `1.5px solid ${filter === c ? '#111' : '#E0E0E0'}`,
                    color: filter === c ? '#fff' : '#888',
                    background: filter === c ? '#111' : 'transparent',
                    cursor: 'pointer', fontFamily: 'Inter', letterSpacing: 1,
                    textTransform: 'uppercase', whiteSpace: 'nowrap',
                    transition: 'all .2s',
                  }}>{c}</button>
                ))}
              </div>
            )}
          </div>

          {filtered.length === 0
            ? <EmptyState
                title={items.length === 0 ? 'No portfolio items yet' : `Nothing under ${filter}`}
                body={items.length === 0
                  ? 'Open the Dashboard to upload photos and videos — drag & drop, set category and title.'
                  : 'Try a different filter or add items in this category from the Dashboard.'} />
            : <StudioMasonry items={filtered} />}
        </div>
      </section>

      <Footer onNav={onNav} />
    </div>
  );
}

/* ─── Editorial row rhythm — recreates the curated gallery cadence ───
   The grid flows through a repeating template of rows, consuming items
   in order. Mixed aspect ratios + scales give a comfortable, varied feel
   so visitors enjoy browsing. No view-count numbers — just the work.

   Row cycle:
     A · three tall verticals (reels / portraits)          9:16
     B · one full-width cinematic band                     21:9
     C · one big feature (left) + two stacked (right)      4:3
     D · four equal squares                                1:1
*/
function StudioMasonry({ items }) {
  // Build rows by consuming items through the repeating template.
  const rows = [];
  let i = 0;
  const cycle = ['A', 'B', 'C', 'D'];
  let c = 0;
  while (i < items.length) {
    const kind = cycle[c % cycle.length];
    if (kind === 'A')      { rows.push({ kind, items: items.slice(i, i + 3) }); i += 3; }
    else if (kind === 'B') { rows.push({ kind, items: items.slice(i, i + 1) }); i += 1; }
    else if (kind === 'C') { rows.push({ kind, items: items.slice(i, i + 3) }); i += 3; }
    else                   { rows.push({ kind, items: items.slice(i, i + 4) }); i += 4; }
    c++;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {rows.map((row, ri) => <StudioRow key={ri} row={row} />)}
    </div>
  );
}

function StudioRow({ row }) {
  const { kind, items } = row;
  const n = items.length;
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;

  // ROW A — three verticals (or fewer if it's the tail)
  if (kind === 'A') {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(n, 3)}, 1fr)`, gap: isMobile ? 8 : 12 }}>
        {items.map((it, i) => <StudioTile key={it.id || i} item={it} aspect="9/16" />)}
      </div>
    );
  }

  // ROW B — one cinematic full-width band
  if (kind === 'B') {
    return (
      <div>
        <StudioTile item={items[0]} aspect={isMobile ? '3/2' : '21/9'} />
      </div>
    );
  }

  // ROW C — big feature left + two stacked right
  if (kind === 'C') {
    if (n === 1) return <div><StudioTile item={items[0]} aspect="16/10" /></div>;
    if (isMobile) {
      return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          {items.map((it, i) => <StudioTile key={it.id || i} item={it} aspect="1/1" />)}
        </div>
      );
    }
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: 12 }}>
        <StudioTile item={items[0]} aspect="4/3" />
        <div style={{ display: 'grid', gridTemplateRows: `repeat(${n - 1}, 1fr)`, gap: 12 }}>
          {items.slice(1).map((it, i) => <StudioTile key={it.id || i} item={it} aspect="auto" fill />)}
        </div>
      </div>
    );
  }

  // ROW D — four equal squares (2×2 on mobile)
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${isMobile ? 2 : Math.min(n, 4)}, 1fr)`, gap: isMobile ? 8 : 12 }}>
      {items.map((it, i) => <StudioTile key={it.id || i} item={it} aspect="1/1" />)}
    </div>
  );
}

function StudioTile({ item, aspect, fill }) {
  const [hover, setHover] = React.useState(false);
  const isVideo = item.type === 'video';
  // 'inline' plays in the in-site lightbox; otherwise the href navigates out.
  const inline = item.playType === 'inline' && (item.videoUrl || item.href);
  const clickable = isVideo ? !!(item.href || inline) : !!item.src;
  const tileStyle = {
    position: 'relative', overflow: 'hidden',
    borderRadius: 10, background: '#EAEAE6',
    textDecoration: 'none', display: 'block',
    cursor: clickable ? 'pointer' : 'default',
  };
  if (fill) { tileStyle.height = '100%'; tileStyle.minHeight = 0; }
  else { tileStyle.aspectRatio = aspect; }

  const activate = (e) => {
    e.preventDefault();
    if (!isVideo) {
      // Photo → open full-resolution in the in-site lightbox
      if (item.src) window.openLightbox && window.openLightbox({ src: item.full || item.src, title: item.title, image: true });
      return;
    }
    if (inline) {
      window.openLightbox && window.openLightbox({ src: item.videoUrl || item.href, title: item.title, poster: item.src });
      return;
    }
    if (!item.href) return;
    try {
      const w = window.open(item.href, '_blank', 'noopener,noreferrer');
      if (!w) window.location.href = item.href;
    } catch (err) { window.location.href = item.href; }
  };

  return (
    <a
      href={inline ? '#' : (item.href || '#')}
      target={!inline && item.href ? '_blank' : null}
      rel={!inline && item.href ? 'noopener noreferrer' : null}
      onClick={activate}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={tileStyle}>
      {item.src
        ? <img src={item.src} alt={item.title || ''} style={{
            position: 'absolute', inset: 0, width: '100%', height: '100%',
            objectFit: 'cover',
            transform: hover ? 'scale(1.05)' : 'scale(1)',
            transition: 'transform .7s cubic-bezier(.16,1,.3,1)',
          }} />
        : <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa', fontSize: 13 }}>No image</div>
      }

      {/* Type badge — PHOTO (green) / VIDEO (dark + play) */}
      <div style={{
        position: 'absolute', top: 14, left: 14,
        display: 'inline-flex', alignItems: 'center', gap: 6,
        background: isVideo ? 'rgba(0,0,0,.7)' : 'var(--ll-accent, #A5FF12)',
        color: isVideo ? '#fff' : '#111',
        fontSize: 10, fontWeight: 800,
        padding: '4px 11px', borderRadius: 4,
        letterSpacing: 1, textTransform: 'uppercase',
        backdropFilter: isVideo ? 'blur(6px)' : 'none',
      }}>
        {isVideo && <svg width="8" height="8" viewBox="0 0 10 10"><polygon points="2,1 9,5 2,9" fill="var(--ll-accent, #A5FF12)" /></svg>}
        {isVideo ? 'Video' : 'Photo'}
      </div>

      {/* Hover overlay — play affordance for video, caption for both */}
      <div style={{
        position: 'absolute', inset: 0,
        background: isVideo
          ? 'rgba(0,0,0,.5)'
          : 'linear-gradient(to top, rgba(0,0,0,.78) 0%, rgba(0,0,0,0) 55%)',
        opacity: hover ? 1 : 0,
        transition: 'opacity .35s ease',
        display: 'flex', flexDirection: 'column',
        alignItems: isVideo ? 'center' : 'flex-start',
        justifyContent: isVideo ? 'center' : 'flex-end',
        gap: isVideo ? 14 : 0,
        padding: 20, textAlign: isVideo ? 'center' : 'left',
      }}>
        {isVideo && (
          <div style={{
            width: 58, height: 58, borderRadius: '50%',
            background: 'var(--ll-accent, #A5FF12)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}>
            <svg width="18" height="18" viewBox="0 0 14 14" fill="#111"><polygon points="3,1 13,7 3,13" /></svg>
          </div>
        )}
        {!isVideo && item.category && (
          <div style={{ fontSize: 10, color: 'var(--ll-accent, #A5FF12)', letterSpacing: 2.5, textTransform: 'uppercase', fontWeight: 800, marginBottom: 6 }}>{item.category}</div>
        )}
        {item.title && (
          <div style={{
            fontWeight: 900, fontSize: isVideo ? 16 : 18, letterSpacing: -0.5,
            color: '#fff', textTransform: 'uppercase', lineHeight: 1.15,
          }}>{item.title}</div>
        )}
      </div>
    </a>
  );
}

/* ─── Discipline (light services strip) ─────────────────────── */
function DisciplineCell({ icon, title, body, last }) {
  const props = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: '#111', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  let svg = null;
  if (icon === 'camera')  svg = <svg {...props}><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>;
  if (icon === 'video')   svg = <svg {...props}><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>;
  if (icon === 'social')  svg = <svg {...props}><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="3"/></svg>;
  if (icon === 'package') svg = <svg {...props}><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 002 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>;
  return (
    <div style={{
      padding: '28px 32px',
      borderRight: last ? 'none' : '1px solid #EAEAE6',
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: 10,
        background: '#FAFAF7',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 14,
      }}>{svg}</div>
      <div style={{ fontWeight: 900, fontSize: 16, letterSpacing: -0.4, color: '#111', textTransform: 'uppercase', marginBottom: 4 }}>{title}</div>
      <div style={{ fontSize: 12, color: '#888', fontWeight: 400, lineHeight: 1.5 }}>{body}</div>
    </div>
  );
}

Object.assign(window, { StudioPage });

/* ===== Source: 0f01c1f8-e448-4247-b39c-eb648b52a211.js ===== */
/* eslint-disable */
// Full project detail page — thinknbox-style. Cover hero, then
// section blocks (BRANDING, CONTENT CREATION, ADVERTISING, INTERIOR DESIGN)
// that ONLY render when the project has data for them. Followed by gallery,
// CTA strip and prev/next pager.

function ProjectPage({ project, onBack, onOpenProject }) {
  const all = window.LL_DATA.projects || [];
  const idx = all.findIndex(p => p.id === project.id);
  const prev = idx > 0 ? all[idx - 1] : all[all.length - 1];
  const next = idx < all.length - 1 ? all[idx + 1] : all[0];
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;

  return (
    <div style={{ background: '#0A0A0A', color: '#fff', minHeight: '100vh' }}>

      {/* ── HERO ─────────────────────────────────────────────── */}
      <div style={{ padding: isMobile ? '96px 24px 32px' : '120px 10% 40px', maxWidth: 1200, margin: '0 auto' }}>
        <button onClick={onBack} style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          fontSize: 12, color: 'rgba(255,255,255,.5)', fontWeight: 700,
          marginBottom: 32, cursor: 'pointer',
          background: 'none', border: 'none', fontFamily: 'Inter',
          letterSpacing: 0.5, textTransform: 'uppercase',
        }}>← Back to Portfolio</button>

        <div style={{ marginBottom: 16 }}>
          <span style={{
            fontSize: 11, background: 'var(--ll-accent, #A5FF12)', color: '#111',
            padding: '4px 12px', borderRadius: 3, fontWeight: 800,
            letterSpacing: 0.3, textTransform: 'uppercase',
          }}>{(project.type || '').toUpperCase()}</span>
        </div>

        <h1 style={{
          fontWeight: 900, fontSize: 'clamp(48px, 7vw, 96px)',
          letterSpacing: -3, lineHeight: 0.92, textTransform: 'uppercase',
          color: '#fff', margin: '0 0 24px',
        }}>{project.name}<span style={{ color: 'var(--ll-accent, #A5FF12)' }}>.</span></h1>

        {project.tagline && (
          <p style={{
            fontSize: 18, color: 'rgba(255,255,255,.6)',
            lineHeight: 1.75, fontWeight: 300, maxWidth: 720, marginBottom: 48,
          }}>{project.tagline}</p>
        )}

        <div style={{
          width: '100%', aspectRatio: '16/9', borderRadius: 12,
          overflow: 'hidden', background: '#111', marginBottom: 32,
        }}>
          {project.cover && <img src={project.cover} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
        </div>
      </div>

      {/* ── META STRIP ─────────────────────────────────────── */}
      <section style={{
        background: '#0D0D0D',
        borderTop: '1px solid rgba(255,255,255,.05)',
        borderBottom: '1px solid rgba(255,255,255,.05)',
        padding: isMobile ? '28px 24px' : '40px 10%',
      }}>
        <div style={{
          maxWidth: 1200, margin: '0 auto',
          display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)', gap: isMobile ? 18 : 24,
        }}>
          <MetaCol label="Client"   value={project.name} />
          <MetaCol label="Industry" value={project.industry || 'Food & Beverage'} />
          <MetaCol label="Year"     value={project.year || '2024'} />
          <MetaCol label="Type"     value={project.type || 'Branding'} />
        </div>
      </section>

      {/* ── PROJECT STORY (always shown) ─────────────────── */}
      {project.story && (
        <section style={{ padding: '64px 10% 24px' }}>
          <div style={{ maxWidth: 900, margin: '0 auto' }}>
            <p style={{ fontSize: 17, color: 'rgba(255,255,255,.7)', lineHeight: 1.85, fontWeight: 300 }}>{project.story}</p>
          </div>
        </section>
      )}

      {/* ── DEPARTMENT SECTIONS ─────────────────────────── */}
      <BrandingSection data={project.branding} palette={project.palette || []} />
      <ContentSection  data={project.content} />
      <AdvertisingSection data={project.advertising} />
      <InteriorSection data={project.interiorDesign} />

      {/* ── GALLERY ─────────────────────────────────────── */}
      {(project.gallery || []).length > 0 && (
        <section style={{ padding: isMobile ? '48px 24px' : '60px 10%', background: '#0D0D0D' }}>
          <div style={{ maxWidth: 1200, margin: '0 auto' }}>
            <SectionTitle eyebrow="Deliverables" title="BRAND GUIDELINES" />
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: isMobile ? 12 : 16 }}>
              {project.gallery.map((src, i) => (
                <a key={i} href={src} target="_blank" style={{
                  display: 'block', borderRadius: 10, overflow: 'hidden',
                  background: '#111',
                  border: '1px solid rgba(255,255,255,.06)', cursor: 'pointer',
                }}>
                  <img src={src} style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'contain' }} />
                </a>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ── CTA ─────────────────────────────────────────── */}
      <section style={{ padding: isMobile ? '56px 24px' : '80px 10%', background: 'var(--ll-accent, #A5FF12)', textAlign: 'center' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <h2 style={{ fontWeight: 900, fontSize: 'clamp(32px, 5vw, 56px)', letterSpacing: -2, textTransform: 'uppercase', color: '#111', margin: '0 0 14px' }}>Want Something Like This?</h2>
          <p style={{ fontSize: 16, color: 'rgba(0,0,0,.6)', fontWeight: 300, marginBottom: 32 }}>Let's talk about building your brand from the ground up.</p>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <BtnDark label="Book Your Free Strategy Call" />
          </div>
        </div>
      </section>

      {/* ── PREV / NEXT ─────────────────────────────────── */}
      <section style={{ padding: isMobile ? '32px 24px 56px' : '40px 10% 80px', background: '#0D0D0D' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 12 : 16 }}>
          <PagerCard direction="prev" project={prev} onClick={() => onOpenProject && onOpenProject(prev)} />
          <PagerCard direction="next" project={next} onClick={() => onOpenProject && onOpenProject(next)} />
        </div>
      </section>
    </div>
  );
}

/* ════════════════ SECTION BLOCKS ════════════════ */

function SectionTitle({ eyebrow, title }) {
  return (
    <div style={{ marginBottom: 36 }}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 style={{
        fontWeight: 900, fontSize: 'clamp(28px, 4vw, 44px)',
        letterSpacing: -1.5, textTransform: 'uppercase',
        color: '#fff', margin: 0,
      }}>{title}</h2>
    </div>
  );
}

// Reusable "card with subhead + body" inside a department section.
function StrategyCard({ label, body }) {
  if (!body) return null;
  return (
    <div style={{
      background: 'rgba(255,255,255,.02)',
      border: '1px solid rgba(255,255,255,.06)',
      borderRadius: 12, padding: 28, marginBottom: 24,
    }}>
      <div style={{ fontSize: 11, color: 'var(--ll-accent, #A5FF12)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 800, marginBottom: 14 }}>{label}</div>
      <p style={{ fontSize: 16, color: 'rgba(255,255,255,.75)', lineHeight: 1.85, fontWeight: 300, margin: 0 }}>{body}</p>
    </div>
  );
}

function BrandingSection({ data, palette }) {
  if (!data || (!data.strategy && (!data.deliverables || data.deliverables.length === 0) && palette.length === 0)) return null;
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  return (
    <section style={{ padding: isMobile ? '56px 24px' : '80px 10%' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <SectionTitle eyebrow="Branding" title="BRAND IDENTITY" />
        <StrategyCard label="Brand Strategy" body={data.strategy} />

        {(data.deliverables || []).length > 0 && (
          <div style={{ marginBottom: 32 }}>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,.4)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginBottom: 14 }}>Deliverables</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {data.deliverables.map((d, i) => (
                <span key={i} style={{
                  fontSize: 12, color: '#fff', background: 'rgba(165,255,18,.1)',
                  border: '1px solid rgba(165,255,18,.3)',
                  padding: '8px 14px', borderRadius: 999, fontWeight: 600,
                }}>{d}</span>
              ))}
            </div>
          </div>
        )}

        {palette.length > 0 && (
          <div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,.4)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginBottom: 14 }}>Brand Palette</div>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? `repeat(${Math.min(palette.length, 3)}, 1fr)` : `repeat(${Math.min(palette.length, 6)}, 1fr)`, gap: 12 }}>
              {palette.map((c, i) => (
                <div key={i}>
                  <div style={{ background: c.hex, height: isMobile ? 80 : 120, borderRadius: 10, border: '1px solid rgba(255,255,255,.06)' }} />
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#fff', marginTop: 10 }}>{c.name}</div>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,.4)', fontFamily: 'ui-monospace, monospace', marginTop: 3 }}>{c.hex}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function ContentSection({ data }) {
  if (!data || (!data.strategy && (!data.platforms || data.platforms.length === 0) && !data.volume && (!data.reels || data.reels.length === 0))) return null;
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  return (
    <section style={{ padding: isMobile ? '56px 24px' : '80px 10%', background: '#0D0D0D' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <SectionTitle eyebrow="Content Creation" title="CONTENT &amp; SOCIAL" />
        <StrategyCard label="Content Strategy" body={data.strategy} />

        {((data.platforms || []).length > 0 || data.volume) && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: isMobile ? 16 : 24, marginBottom: 32 }}>
            {(data.platforms || []).length > 0 && (
              <div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,.4)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginBottom: 12 }}>Platforms</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {data.platforms.map((p, i) => (
                    <span key={i} style={{
                      fontSize: 12, color: 'var(--ll-accent, #A5FF12)', background: 'rgba(165,255,18,.1)',
                      border: '1px solid rgba(165,255,18,.3)',
                      padding: '8px 14px', borderRadius: 6, fontWeight: 700,
                    }}>{p}</span>
                  ))}
                </div>
              </div>
            )}
            {data.volume && (
              <div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,.4)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginBottom: 12 }}>Content Volume</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#fff', letterSpacing: -0.5 }}>{data.volume}</div>
              </div>
            )}
          </div>
        )}

        {(data.reels || []).length > 0 && (
          <div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,.4)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginBottom: 14 }}>Featured Reels</div>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', gap: isMobile ? 8 : 12 }}>
              {data.reels.map((r, i) => (
                <a key={i} href={r.url || '#'} target={r.url ? '_blank' : null} style={{
                  position: 'relative', display: 'block', borderRadius: 10, overflow: 'hidden',
                  aspectRatio: '9/16', background: '#111', cursor: r.url ? 'pointer' : 'default',
                  textDecoration: 'none',
                }}>
                  {r.img && <img src={r.img} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,.85) 0%, transparent 60%)' }} />
                  {r.label && (
                    <div style={{ position: 'absolute', bottom: 12, left: 14, right: 14, fontSize: 13, fontWeight: 700, color: '#fff' }}>{r.label}</div>
                  )}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function AdvertisingSection({ data }) {
  if (!data || (!data.strategy && (!data.stats || data.stats.length === 0))) return null;
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  return (
    <section style={{ padding: isMobile ? '56px 24px' : '80px 10%' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <SectionTitle eyebrow="Advertising" title="PAID MEDIA" />
        <StrategyCard label="Campaign Strategy" body={data.strategy} />

        {(data.stats || []).length > 0 && (
          <div>
            <div style={{ fontSize: 11, color: 'var(--ll-accent, #A5FF12)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 800, marginBottom: 16 }}>{data.statsLabel || 'Lifetime Results'}</div>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', gap: isMobile ? 8 : 12 }}>
              {data.stats.map((s, i) => (
                <div key={i} style={{
                  background: 'rgba(255,255,255,.02)',
                  border: '1px solid rgba(255,255,255,.06)',
                  borderRadius: 12, padding: '28px 24px',
                }}>
                  <div style={{ fontSize: 32, fontWeight: 900, color: 'var(--ll-accent, #A5FF12)', letterSpacing: -1.5, lineHeight: 1, marginBottom: 8 }}>{s.n}</div>
                  <div style={{ fontSize: 10, color: 'rgba(255,255,255,.45)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700 }}>{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function InteriorSection({ data }) {
  if (!data || (!data.strategy && (!data.images || data.images.length === 0))) return null;
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  return (
    <section style={{ padding: isMobile ? '56px 24px' : '80px 10%', background: '#0D0D0D' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <SectionTitle eyebrow="Interior Design" title="THE SPACE" />
        <StrategyCard label="Design Concept" body={data.strategy} />
        {(data.images || []).length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: isMobile ? 12 : 16 }}>
            {data.images.map((src, i) => (
              <div key={i} style={{ borderRadius: 10, overflow: 'hidden', aspectRatio: '4/3', background: '#111' }}>
                <img src={src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

/* ════════════════ META / PAGER ════════════════ */

function MetaCol({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 10, color: 'rgba(255,255,255,.35)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 15, fontWeight: 800, color: '#fff', lineHeight: 1.4 }}>{value}</div>
    </div>
  );
}

function PagerCard({ direction, project, onClick }) {
  const [hover, setHover] = React.useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: '#1a1a1a',
        border: `1px solid ${hover ? 'var(--ll-accent, #A5FF12)' : 'rgba(255,255,255,.06)'}`,
        borderRadius: 12, padding: 28,
        display: 'flex', alignItems: 'center',
        flexDirection: direction === 'prev' ? 'row' : 'row-reverse',
        justifyContent: 'space-between', cursor: 'pointer',
        transition: 'border-color .3s',
      }}>
      <div style={{ textAlign: direction === 'prev' ? 'left' : 'right' }}>
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,.3)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginBottom: 6 }}>
          {direction === 'prev' ? '← Previous' : 'Next →'}
        </div>
        <div style={{ fontWeight: 900, fontSize: 22, letterSpacing: -1, color: hover ? 'var(--ll-accent, #A5FF12)' : '#fff', textTransform: 'uppercase', transition: 'color .2s' }}>{project.name}</div>
      </div>
      <div style={{ width: 80, height: 60, borderRadius: 8, overflow: 'hidden', background: '#0a0a0a' }}>
        {project.cover && <img src={project.cover} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
      </div>
    </div>
  );
}

Object.assign(window, { ProjectPage });

/* ===== Source: e54f242e-964a-4909-ad03-6c36f51d5449.js ===== */
/* eslint-disable */
// Renders the user-added "Custom Sections" on the Home page below the brands.

function CustomSections() {
  const sections = (window.LL_DATA.customSections || []);
  if (sections.length === 0) return null;
  return (
    <>
      {sections.map(s => <CustomSection key={s.id} section={s} />)}
    </>
  );
}

function CustomSection({ section }) {
  const items = section.items || [];
  const cols = ({ grid2: 2, grid3: 3, grid4: 4, wide: 1, stack: 1 })[section.layout || 'grid3'] || 3;
  const aspect = section.layout === 'wide' ? '21/9'
               : section.layout === 'stack' ? '4/1'
               : section.layout === 'grid4' ? '1/1' : '4/3';
  return (
    <section style={{ background: '#fff', padding: '100px 10%', borderTop: '1px solid #EAEAE6' }}>
      <div style={{ marginBottom: 36 }}>
        {section.eyebrow && <Eyebrow>{section.eyebrow}</Eyebrow>}
        <h2 style={{
          fontWeight: 900, fontSize: 'clamp(32px, 5vw, 64px)',
          letterSpacing: -2, lineHeight: .95, textTransform: 'uppercase',
          color: '#111', margin: 0,
        }}>{section.title}</h2>
      </div>
      {items.length === 0
        ? <EmptyState
            title={`"${section.title}" is empty`}
            body="Drop images into this section from the Dashboard." />
        : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${cols}, 1fr)`,
            gap: 14,
          }}>
            {items.map((it, i) => (
              <div key={it.id || i} style={{
                borderRadius: 10, overflow: 'hidden', background: '#EAEAE6',
                aspectRatio: aspect, position: 'relative',
              }}>
                <img src={it.src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                {(it.title || it.subtitle) && (
                  <div style={{
                    position: 'absolute', bottom: 0, left: 0, right: 0,
                    background: 'linear-gradient(to top, rgba(0,0,0,.85), transparent)',
                    padding: '20px 18px 16px', color: '#fff',
                  }}>
                    {it.title && <div style={{ fontSize: 16, fontWeight: 800, letterSpacing: -.4 }}>{it.title}</div>}
                    {it.subtitle && <div style={{ fontSize: 11, color: 'var(--ll-accent, #A5FF12)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, marginTop: 4 }}>{it.subtitle}</div>}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
    </section>
  );
}

Object.assign(window, { CustomSections });


/* ===== Page components (from inline App script) ===== */
function HomePage({ onNav, onOpen }) {
  return (
    <>
      <Hero onNav={onNav} />
      <ServicesGrid />
      <Marquee />
      <ReelsGrid />
      <BrandsGrid onNav={onNav} onOpen={onOpen} />
      <CustomSections />
      <CtaStrip onNav={onNav} />
      <Footer onNav={onNav} />
    </>
  );
}

function WorkPage({ onNav, onOpen }) {
  const [filter, setFilter] = useState('ALL PROJECTS');
  const filters = ['ALL PROJECTS', 'BRANDING', 'CONTENT CREATION', 'SOCIAL MEDIA', 'ADVERTISING'];
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  return (
    <>
      <section style={{ padding: isMobile ? '100px 24px 40px' : '120px 10% 56px', background: '#fff' }}>
        <Eyebrow>Our Portfolio</Eyebrow>
        <h1 style={{
          fontWeight: 900, fontSize: 'clamp(48px, 9vw, 120px)',
          letterSpacing: -4, lineHeight: .9, textTransform: 'uppercase',
          color: '#111', margin: '0 0 20px',
        }}>WORK THAT<br/>WORKS<span style={{ color: '#A5FF12' }}>.</span></h1>
        <p style={{ fontSize: 15, color: '#888', maxWidth: 440, lineHeight: 1.7, fontWeight: 300 }}>
          Every project is a partnership. Every result is measurable.
        </p>
      </section>
      <Services2x2 />
      <div style={{
        display: 'flex', gap: isMobile ? 8 : 10, padding: isMobile ? '20px 24px 24px' : '24px 10% 32px',
        flexWrap: 'wrap', background: '#fff',
        borderTop: '1px solid #EAEAE6',
      }}>
        {filters.map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{
            fontSize: isMobile ? 11 : 12, fontWeight: 700, padding: isMobile ? '8px 16px' : '10px 24px', borderRadius: 999,
            border: `1.5px solid ${filter === f ? '#111' : '#E0E0E0'}`,
            color: filter === f ? '#fff' : '#888',
            background: filter === f ? '#111' : 'transparent',
            cursor: 'pointer', fontFamily: 'Inter', letterSpacing: 1,
            textTransform: 'uppercase', transition: 'all .2s', whiteSpace: 'nowrap',
          }}>{f}</button>
        ))}
      </div>
      <WorkGrid onOpen={onOpen} />
      <ReelsGrid />
      <BrandsGrid onNav={onNav} onOpen={onOpen} />
      <Footer onNav={onNav} />
    </>
  );
}

function AboutPage({ onNav }) {
  const a = window.LL_DATA.about || {};
  const h1Lines = (a.h1 || '').split('\n');
  const missionLines = (a.missionTitle || '').split('\n');
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  return (
    <>
      <section style={{
        minHeight: isMobile ? 'auto' : '92vh', background: '#fff',
        display: 'flex', flexDirection: 'column', justifyContent: 'center',
        padding: isMobile ? '96px 24px 56px' : '120px 10% 80px', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', right: -20, top: '50%', transform: 'translateY(-50%)',
          fontWeight: 900, fontSize: '28vw', letterSpacing: -10,
          color: 'transparent', WebkitTextStroke: '1px rgba(0,0,0,.04)',
          pointerEvents: 'none', userSelect: 'none', lineHeight: 1,
        }}>LARINZ</div>
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 900 }}>
          <Eyebrow>{a.eyebrow || 'Who We Are'}</Eyebrow>
          <h1 style={{
            fontWeight: 900, fontSize: 'clamp(48px, 8vw, 110px)',
            letterSpacing: -4, lineHeight: .9, textTransform: 'uppercase',
            color: '#111', margin: '0 0 32px',
          }}>
            {h1Lines.map((line, i) => {
              const isLast = i === h1Lines.length - 1;
              return <React.Fragment key={i}>
                {isLast ? <span style={{ color: '#A5FF12' }}>{line}</span> : line}
                {i < h1Lines.length - 1 && <br/>}
              </React.Fragment>;
            })}
          </h1>
          <p style={{ fontSize: 18, color: '#444', lineHeight: 1.8, maxWidth: 640, fontWeight: 300, marginBottom: 48 }}>{a.intro}</p>
          <div style={{ display: 'flex', gap: 12 }}>
            <BtnGreen label="See Our Work" onClick={() => onNav('work')} />
            <BtnOutline label="Get In Touch" onClick={() => onNav('contact')} />
          </div>
        </div>
      </section>

      <section style={{ background: '#0D0D0D', padding: isMobile ? '56px 24px' : '100px 10%' }}>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 40 : 80, alignItems: 'center', maxWidth: 1200 }}>
          <div>
            <Eyebrow>Our Mission</Eyebrow>
            <h2 style={{
              fontWeight: 900, fontSize: 'clamp(32px, 5vw, 64px)',
              letterSpacing: -2, lineHeight: .95, textTransform: 'uppercase',
              color: '#fff', margin: 0,
            }}>
              {missionLines.map((line, i) => {
                const isLast = i === missionLines.length - 1;
                return <React.Fragment key={i}>
                  {isLast ? <span style={{ color: '#A5FF12' }}>{line}</span> : line}
                  {i < missionLines.length - 1 && <br/>}
                </React.Fragment>;
              })}
            </h2>
            <p style={{ fontSize: 15, color: 'rgba(255,255,255,.45)', maxWidth: '100%', marginTop: 20, lineHeight: 1.75, fontWeight: 300 }}>{a.missionBody}</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {(a.stats || []).map((s, i) => (
              <div key={i} style={{
                background: '#1a1a1a', border: '1px solid rgba(255,255,255,.06)',
                borderRadius: 10, padding: 28, textAlign: 'center',
              }}>
                <div style={{ fontWeight: 900, fontSize: 44, letterSpacing: -2, lineHeight: 1, color: '#fff' }}>
                  {s.n}<span style={{ color: '#A5FF12' }}>{s.s}</span>
                </div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,.3)', marginTop: 7, letterSpacing: 2, textTransform: 'uppercase', fontWeight: 600 }}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ background: '#F5F5F5', padding: isMobile ? '56px 24px' : '100px 10%' }}>
        <Eyebrow>What Drives Us</Eyebrow>
        <h2 style={{
          fontWeight: 900, fontSize: 'clamp(32px, 5vw, 64px)',
          letterSpacing: -2, lineHeight: .95, textTransform: 'uppercase',
          color: '#111', margin: 0,
        }}>OUR VALUES</h2>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: isMobile ? 14 : 20, marginTop: isMobile ? 32 : 52 }}>
          {(a.values || []).map((v, i) => (
            <div key={i} style={{
              background: '#fff', border: '1px solid #E0E0E0',
              borderRadius: 10, padding: 36,
            }}>
              <div style={{ marginBottom: 18, color: '#111' }}>
                <Icon name={v.iconName || emojiToIcon(v.icon) || 'target'} size={28} color="var(--ll-accent, #A5FF12)" strokeWidth={2} />
              </div>
              <div style={{ fontWeight: 900, fontSize: 18, letterSpacing: -0.5, color: '#111', textTransform: 'uppercase', marginBottom: 10 }}>{v.title}</div>
              <div style={{ fontSize: 14, color: '#888', lineHeight: 1.7, fontWeight: 300 }}>{v.desc}</div>
            </div>
          ))}
        </div>
      </section>

      <section style={{ background: '#A5FF12', padding: isMobile ? '56px 24px' : '80px 10%', textAlign: 'center' }}>
        <h2 style={{ fontWeight: 900, fontSize: 'clamp(36px, 5vw, 64px)', letterSpacing: -2, textTransform: 'uppercase', color: '#111', margin: '0 0 14px' }}>READY TO START?</h2>
        <p style={{ fontSize: 16, color: 'rgba(0,0,0,.55)', marginBottom: 32, fontWeight: 300 }}>Let's build something unforgettable together.</p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <BtnDark label="Book Free Strategy Call" onClick={() => onNav('contact')} />
        </div>
      </section>

      <Footer onNav={onNav} />
    </>
  );
}

function ContactPage({ onNav }) {
  const c = window.LL_DATA.contact || {};
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  const [form, setForm] = useState({ name: '', email: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const submit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) { alert('Please add your name and email.'); return; }
    // POST to backend (with localStorage fallback for offline parity with the
    // original source app).
    (async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: form.name.trim(),
            email: form.email.trim(),
            service: form.service,
            message: form.message.trim(),
          }),
        });
        if (!r.ok) throw new Error('post-failed');
      } catch (err) {
        try {
          const KEY = 'larinz-labz-messages';
          const list = JSON.parse(localStorage.getItem(KEY) || '[]');
          list.unshift({ id: Date.now(), name: form.name.trim(), email: form.email.trim(), service: form.service, body: form.message.trim(), created_at: new Date().toISOString(), read: false });
          localStorage.setItem(KEY, JSON.stringify(list));
        } catch (e) { console.warn('localStorage contact fallback failed:', e); }
      }
    })();
    setSubmitted(true);
    setForm({ name: '', email: '', service: '', message: '' });
  };
  return (
    <>
      <div style={{ minHeight: isMobile ? 'auto' : 'calc(100vh - 68px)', background: '#fff', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr' }}>
        <div style={{ padding: isMobile ? '64px 24px 56px' : '80px 8%', background: '#0D0D0D', display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', bottom: -100, left: -100, width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(165,255,18,.08) 0%, transparent 70%)' }} />
          <Eyebrow>Get In Touch</Eyebrow>
          <h1 style={{
            fontWeight: 900, fontSize: 'clamp(44px, 6vw, 80px)',
            letterSpacing: -3, lineHeight: .9, textTransform: 'uppercase',
            color: '#fff', margin: '0 0 24px',
          }}>LET'S<br/>BUILD<br/><span style={{ color: '#A5FF12' }}>SOMETHING.</span></h1>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,.42)', lineHeight: 1.75, fontWeight: 300, marginBottom: 48, maxWidth: 380 }}>
            Ready to dominate your market? Book a free strategy session and let's talk about what we can build together.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <ContactRow icon="mail"      label="Email"     value={c.email} />
            <ContactRow icon="instagram" label="Instagram" value={c.instagram} />
            <ContactRow icon="pin"       label="Location"  value={c.location} />
          </div>
        </div>
        <div style={{ padding: isMobile ? '48px 24px 64px' : '80px 8%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <h2 style={{ fontWeight: 900, fontSize: 22, letterSpacing: -1, color: '#111', marginBottom: 32, textTransform: 'uppercase' }}>START A PROJECT</h2>
          {submitted ? (
            <div style={{
              background: '#FAFFF0', border: '1.5px solid #A5FF12', borderRadius: 10,
              padding: '32px 28px', textAlign: 'center',
            }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: '#A5FF12', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              </div>
              <div style={{ fontWeight: 900, fontSize: 18, color: '#111', textTransform: 'uppercase', letterSpacing: -0.5, marginBottom: 8 }}>Message received</div>
              <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6, margin: '0 0 18px' }}>Thanks — we've received your message and will be in touch with you soon.</p>
              <span onClick={() => setSubmitted(false)} style={{ fontSize: 12, color: '#888', cursor: 'pointer', fontWeight: 700, textDecoration: 'underline' }}>Send another →</span>
            </div>
          ) : (
            <form style={{ display: 'flex', flexDirection: 'column', gap: 14 }} onSubmit={submit}>
              <Field label="Your Name" placeholder="Full name" value={form.name} onChange={v => setF('name', v)} />
              <Field label="Email" placeholder="your@email.com" type="email" value={form.email} onChange={v => setF('email', v)} />
              <FieldSelect label="Service" value={form.service} onChange={v => setF('service', v)} />
              <Field label="Message" placeholder="Tell us about your project..." textarea value={form.message} onChange={v => setF('message', v)} />
              <BtnGreen label="Send Message" />
            </form>
          )}
        </div>
      </div>
      <Footer onNav={onNav} />
    </>
  );
}

function ContactRow({ icon, label, value }) {
  if (!value) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
      <div style={{
        width: 44, height: 44, borderRadius: 8,
        background: 'rgba(165,255,18,.08)', border: '1px solid rgba(165,255,18,.2)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}><Icon name={icon} size={20} color="#A5FF12" /></div>
      <div>
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,.28)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 3, fontWeight: 700 }}>{label}</div>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>{value}</div>
      </div>
    </div>
  );
}

function Field({ label, placeholder, type = 'text', textarea, value = '', onChange }) {
  const [focus, setFocus] = useState(false);
  const common = {
    width: '100%', padding: '13px 15px',
    background: focus ? '#fff' : '#F5F5F5',
    border: `1.5px solid ${focus ? '#A5FF12' : '#E0E0E0'}`,
    borderRadius: 6, color: '#111', fontSize: 14,
    fontFamily: 'Inter, sans-serif', outline: 'none',
    transition: 'border-color .2s, background .2s',
  };
  const handle = e => onChange && onChange(e.target.value);
  return (
    <div>
      <label style={{ fontSize: 10, color: '#888', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 7, fontWeight: 700, display: 'block' }}>{label}</label>
      {textarea
        ? <textarea placeholder={placeholder} value={value} onChange={handle} style={{ ...common, resize: 'none', height: 110 }} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} />
        : <input type={type} placeholder={placeholder} value={value} onChange={handle} style={common} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} />}
    </div>
  );
}

function FieldSelect({ label, value = '', onChange }) {
  const opts = ['Photography', 'Videography', 'Social Media Management', 'Brand Strategy', 'Full Package'];
  return (
    <div>
      <label style={{ fontSize: 10, color: '#888', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 7, fontWeight: 700, display: 'block' }}>{label}</label>
      <select value={value} onChange={e => onChange && onChange(e.target.value)} style={{
        width: '100%', padding: '13px 15px', background: '#F5F5F5',
        border: '1.5px solid #E0E0E0', borderRadius: 6,
        color: value ? '#111' : '#888', fontSize: 14, fontFamily: 'Inter, sans-serif', outline: 'none',
      }}>
        <option value="">What do you need?</option>
        {opts.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}

function CtaStrip({ onNav }) {
  const isMobile = window.useIsMobile ? window.useIsMobile() : false;
  return (
    <section style={{ background: '#111', padding: isMobile ? '56px 24px' : '100px 10%', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: -200, right: -100, width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(165,255,18,.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 32 : 72, alignItems: 'center', position: 'relative', zIndex: 1 }}>
        <div>
          <Eyebrow>Let's Talk</Eyebrow>
          <h2 style={{ fontWeight: 900, fontSize: 'clamp(40px, 5.5vw, 72px)', letterSpacing: -2.5, lineHeight: .92, color: '#fff', textTransform: 'uppercase', margin: '0 0 16px' }}>
            READY TO<br />BUILD <span style={{ color: '#A5FF12' }}>SOMETHING<br />UNFORGETTABLE?</span>
          </h2>
          <p style={{ fontSize: 16, color: 'rgba(255,255,255,.45)', lineHeight: 1.7, fontWeight: 300 }}>
            A free 30-minute strategy session. No fluff. Just a clear plan for how we'd grow your brand.
          </p>
        </div>
        <div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 32 }}>
            {['Real ROI tracking on every deliverable', 'Dedicated team, not a freelancer carousel', 'Content that actually moves the needle'].map((f, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 14, color: 'rgba(255,255,255,.7)', fontWeight: 500 }}>
                <div style={{ width: 22, height: 22, borderRadius: 4, background: '#A5FF12', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#111', flexShrink: 0, fontWeight: 900 }}>✓</div>
                {f}
              </div>
            ))}
          </div>
          <BtnGreen label="Book Your Free Audit" onClick={() => onNav('contact')} />
        </div>
      </div>
    </section>
  );
}

if (typeof window !== 'undefined') {
  Object.assign(window, {
    useIsMobile, useViewport, MediaLightbox, openLightbox,
    EmptyState, Icon, emojiToIcon, Logo, Monogram,
    BtnGreen, BtnDark, BtnOutline, BtnGhost, Eyebrow,
    Nav, Hero, MediaLayer,
    ServicesGrid, ServiceCard, Services2x2, Service2x2Card, ServiceModal,
    ReelsGrid, CarouselArrow, ReelCard,
    BrandsGrid, BrandCard, WorkGrid, WorkItem,
    Marquee, Footer, FtCol,
    StudioPage, StudioMasonry, StudioRow, StudioTile, DisciplineCell,
    ProjectPage, SectionTitle, StrategyCard, BrandingSection, ContentSection,
    AdvertisingSection, InteriorSection, MetaCol, PagerCard,
    CustomSections, CustomSection,
    HomePage, WorkPage, AboutPage, ContactPage, CtaStrip,
    ContactRow, Field, FieldSelect,
  });
}

export {
  Nav, Hero, Footer, MediaLightbox,
  HomePage, WorkPage, AboutPage, ContactPage,
  StudioPage, ProjectPage,
};
